export const de = {
  'authentification': {
    'bienvenu': 'Willkommen',
    'commande_en_ligne': 'Online-Bestellung',
    'compte_france_frais': 'Haben Sie ein Konto?',
    'connectez_vous': 'Melden Sie sich an',
    'premiere_connexion': 'Erste Anmeldung?',
    'utiliser_email': 'Verwenden Sie Ihre Kontakt-E-Mail-Adresse, um sich zu registrieren und auf Ihr Konto zuzugreifen.',
    'activer_compte': 'Anmelden',
    'devenir_client': 'Kunde bei France Frais werden',
    'contactez_nous': 'Kontaktieren Sie uns',
    'tout_proche': 'France Frais, ganz in Ihrer Nähe',
    'de_vous': '!',
    'error': {
      'erreur_rencontree': 'Ein Fehler ist aufgetreten',
      'valider_email': 'Sie müssen bestätigen, dass Sie der Inhaber der E-Mail-Adresse sind, indem Sie auf die Ihnen zugesandte E-Mail klicken.',
      'email_envoye': 'E-Mail gesendet, bitte überprüfen Sie Ihr E-Mail-Postfach.',
      're_envoyer': 'Erneut senden',
      'erreur': 'Fehler',
      'champs_requis': 'Bitte füllen Sie alle erforderlichen Felder aus',
      'date_fin_validite_requise': 'Ablaufdatum ist erforderlich',
      'echec_demande_derogation': 'Fehler beim Senden der Ausnahmeanfrage',
      'erreur_inconnue': 'Ein unbekannter Fehler ist aufgetreten',
      'contacter_commercial': 'Bitte kontaktieren Sie Ihren Vertriebsmitarbeiter.',
      'email_correspond_plus': 'Ihre E-Mail entspricht keinem Kontakt mehr in unserer Kundendatenbank. Bitte kontaktieren Sie Ihren Vertriebsmitarbeiter.',
      'no_sandbox': 'Sie können sich nicht in der Sandbox anmelden.<br /><br />Um auf France Frais Connect zuzugreifen, verwenden Sie bitte den folgenden Link:<br /><br /><Link>https://ffconnect.france-frais.fr</Link>.',
      'switched': 'Sie haben in einem anderen Tab das Kundenkonto gewechselt. <br /><Link>Neu laden</Link>',
      'not_representant': 'Zugriff verweigert. Diese Oberfläche ist den Handelsvertretern von France Frais vorbehalten.'
    }
  },
  'global': {
    'france_frais': 'France Frais',
    'erreur_chargement': 'Fehler beim Laden',
    'selectionner': 'Auswählen',
    'selectionne': 'Ausgewählt',
    'produit': '{{count}} Produkt',
    'produit_one': '{{count}} Produkt',
    'produit_other': '{{count}} Produkte',
    'produit_many': '{{count}} Produkte',
    'produit_plural': '{{count}} Produkte',
    'panier': '{{count}} Warenkorb',
    'panier_one': '{{count}} Warenkorb',
    'panier_other': '{{count}} Warenkörbe',
    'panier_many': '{{count}} Warenkörbe',
    'panier_plural': '{{count}} Warenkörbe',
    'colis': '{{count}} Paket',
    'colis_one': '{{count}} Paket',
    'colis_other': '{{count}} Pakete',
    'colis_many': '{{count}} Pakete',
    'colis_plural': '{{count}} Pakete',
    'annuler': 'Abbrechen',
    'valider': 'Bestätigen',
    'envoyer': 'Senden',
    'retour': 'Zurück',
    'voir': 'Ansehen',
    'remplacer': 'Ersetzen',
    'consulter': 'Einsehen',
    'choisir': 'Wählen',
    'creer': 'Liste erstellen',
    'client_title': 'Kunde',
    'client': '{{count}} Kunde',
    'client_one': '{{count}} Kunde',
    'client_other': '{{count}} Kunden',
    'client_many': '{{count}} Kunden',
    'client_plural': '{{count}} Kunden',
    'a_valider': 'Zu bestätigen',
    'promotion': 'Angebot',
    'produit_marche': 'Marktprodukt',
    'accueil': 'Startseite',
    'catalogue': 'Katalog',
    'cadencier': 'Bestellvorlage',
    'ub_essentielles': 'Essenzielle UBs',
    'mon_cadencier': 'Bestellvorlage',
    'listes': 'Listen',
    'mes_listes': 'Listen',
    'profil': 'Profil',
    'recherche': 'Suche',
    'chargement': 'Wird geladen',
    'revenir': 'Zurückkehren',
    'connecter': 'Anmelden',
    'accepter': 'Ich akzeptiere',
    'refuser': 'Ablehnen',
    'voir_mon_panier': 'Meinen Warenkorb ansehen',
    'choisir_livraison': 'Eine Lieferung wählen',
    'logo': 'Logo',
    'raison_sociale': 'Firma',
    'code': 'Code',
    'attention': 'Achtung',
    'modifier': 'Ändern',
    'compris': 'Verstanden',
    'jai_compris': 'Ich habe verstanden',
    'alt_logo_france_frais': 'Logo France Frais',
    'jour': 'Tag',
    'mois': 'Monat',
    'mois_precedent': 'Vorheriger Monat',
    'mois_suivant': 'Nächster Monat',
    'date': 'Datum',
    'quantite': 'Menge',
    'fiche_produit': 'Produktdatenblatt',
    'not_found': 'Nicht gefunden',
    'error': 'Fehler',
    'error_field_required': 'Dieses Feld ist erforderlich.',
    'loading': 'Wird geladen...',
    'clear_file': 'Datei löschen',
    'articles': 'Artikel',
    'change_selection': 'Auswahl ändern',
    'searching': 'Suche...',
    'supprimer': 'Löschen',
    'oui': 'Ja',
    'non': 'Nein',
    'fermer': 'Schließen',
    'yes': 'Ja',
    'no': 'Nein',
    'all': 'Alle',
    'reset_filters': 'Filter zurücksetzen',
    'vous': 'Sie',
    'fichier_trop_volumineux': 'Datei "{{nom}}" überschreitet die 5 MB Grenze',
    'reference': 'Referenz',
    'telecharger': 'Herunterladen',
    'evenement': '{{count}} Ereignis',
    'evenement_one': '{{count}} Ereignis',
    'evenement_other': '{{count}} Ereignisse',
    'evenement_many': '{{count}} Ereignisse',
    'evenement_plural': '{{count}} Ereignisse',
    'message': 'Nachricht'
  },
  'header_band': {
    'temps_restant': 'Denken Sie daran, so früh wie möglich für Ihre nächste Lieferung am <Text>{{date_de_livraison}}</Text> zu bestellen!',
    'contactez_nous': 'Kontaktieren Sie uns'
  },
  'paiement_cb_notice': {
    'titre': 'Kartenzahlung',
    'message': 'Nur Lieferungen innerhalb der nächsten {{jours}} Tage können bestellt werden',
    'fermer': 'Banner schließen'
  },
  'cadencier': {
    'retirer_des_produits': 'Produkte entfernen',
    'cta_panier': 'Zum Warenkorb gehen',
    'mon_cadencier': 'Meine Bestellvorlage',
    'quitter_edition': 'Bearbeitungsmodus verlassen',
    'chargement_cadencier': 'Laden Ihrer Bestellvorlage',
    'effacer_recherche': 'Suche löschen',
    'aucun_article_filtre': 'Keine Artikel entsprechen den ausgewählten Filtern.',
    'aucune_ligne_tendance': 'Keine {{tendances}}-Zeile in dieser Bestellvorlage',
    'filtres_tendance': {
      'tout': 'Alle',
      'en-hausse': 'Steigend',
      'gagne': 'Gewonnen',
      'stable': 'Stabil',
      'en-baisse': 'Fallend',
      'perdu': 'Verloren',
      'a-gagner': 'Nicht bestellt',
    },
    'suggestion': {
      'texte': 'Vorschlag: {{count}} {{unite}}',
      'tooltip': 'Basierend auf Ihren Einkaufsgewohnheiten',
      'remplir_avec_suggestions': 'Meinen Warenkorb automatisch füllen',
      'articles_ajoutes_au_panier': '{{count}} Artikel erfolgreich zum Warenkorb hinzugefügt',
      'articles_ajoutes_au_panier_one': '{{count}} Artikel erfolgreich zum Warenkorb hinzugefügt',
      'articles_ajoutes_au_panier_other': '{{count}} Artikel erfolgreich zum Warenkorb hinzugefügt',
      'articles_ajoutes_au_panier_many': '{{count}} Artikel erfolgreich zum Warenkorb hinzugefügt',
      'article_changement_quantite': 'Die Menge des Artikels wurde erfolgreich geändert',
      'remplissez_votre_panier': 'Ihr Warenkorb mit einem Klick!',
      'ajoutez_en_un_clic': 'Maßgeschneidert: Finden Sie mit einem Klick Ihre gewohnten Produkte und Mengen.',
      'quantite_suggeree_presente': 'Menge automatisch basierend auf Ihren Gewohnheiten hinzugefügt - ändern Sie sie bei Bedarf.',
      'savoir_plus': 'Mehr erfahren',
      'savoir_plus_tooltip': 'Die Produkte Ihrer Bestellvorlage, die einen Mengenvorschlag basierend auf Ihren Gewohnheiten haben, werden dem Warenkorb hinzugefügt.',
      'action_annulee': '{{count}} Artikel storniert',
      'action_annulee_one': '{{count}} Artikel storniert',
      'action_annulee_other': '{{count}} Artikel storniert',
      'action_annulee_many': '{{count}} Artikel storniert',
      'action_annulee_plural': '{{count}} Artikel storniert',
      'annulation_echouee': 'Die Stornierung ist fehlgeschlagen',
      'ligne_introuvable': 'Warenkorbzeile für Artikel {{code_article}} nicht gefunden',
      'pas_suggestions_disponibles': 'Keine Mengenvorschläge in Ihrer Bestellvorlage verfügbar.',
    },
    'tri': {
      'tri': 'Sortieren: ',
      'alphabetique': 'Alphabetisch',
      'frequence': 'Kaufhäufigkeit'
    },
    'filtre': {
      'promotions': 'Aktionen',
      'labels': 'Etiketten',
      'fromage': 'Käse',
    },
    'modale_retirer': {
      'titre': 'Aus Bestellvorlage entfernen',
      'selectionner_raison': 'Grund auswählen:',
      'raison_plus_de_commande': 'Ich bestelle dieses Produkt nicht mehr',
      'raison_pas_interesse': 'Ich bin nicht an diesem Produkt interessiert',
      'raison_autre_similaire': 'Ich habe ein ähnliches Produkt',
      'raison_deja_ailleurs': 'Ich bestelle dieses Produkt bereits woanders',
      'valider_et_retirer': 'Bestätigen und aus Bestellvorlage entfernen',
      'annuler': 'Abbrechen'
    }
  },
  'temperature_livraison': {
    'la_livraison_du': 'Die Lieferung vom',
    'surgeles_uniquement': 'Nur Tiefkühlprodukte',
    'non_surgeles_uniquement': 'Nur Nicht-Tiefkühlprodukte',
    'livraison_surgelee': 'Tiefkühllieferung',
    'pas_de_surgele': 'Keine Tiefkühlprodukte',
    'livraison_non_surgelee': 'Lieferung ohne Tiefkühlprodukte',
    'livraison_surgeles_uniquement': 'Nur Tiefkühllieferung',
    'livraison_non_surgeles_uniquement': 'Nur Lieferung ohne Tiefkühlprodukte',
    'est_livraison_surgeles_uniquement': 'ist eine reine Tiefkühllieferung.',
    'est_livraison_non_surgeles_uniquement': 'ist eine reine Lieferung ohne Tiefkühlprodukte.',
    'warning_temperature_ignoree': 'Achtung: Die angezeigten Produkte sind möglicherweise für diese Liefertemperatur nicht verfügbar'
  },
  'toast': {
    'ajoute_panier_date': 'Produkt <strong>zum Warenkorb vom {{date, datetime}} hinzugefügt</strong>',
    'modifie_panier_date': 'Produktmenge <strong>in Ihrem Warenkorb vom {{date, datetime}}</strong> geändert',
    'supprime_panier': 'Produkt aus dem Warenkorb entfernt',
    'supprime_cadencier': 'Das Produkt Nr. {{code_article}} wurde aus der Bestellvorlage entfernt',
    'supprime_cadencier_simulation': 'Das Produkt Nr. {{code_article}} wurde nicht wirklich aus der Bestellvorlage entfernt',
    'supprime_cadencier_safelive': 'Das Produkt Nr. {{code_article}} wurde wirklich aus der Bestellvorlage entfernt.<br />Damit es berücksichtigt wird, fügen Sie es sofort aus der Bestellvorlage hinzu',
    'supprime_liste': 'Das Produkt Nr. {{code_article}} wurde aus der Liste entfernt',
    'warning_minimum': 'Die Mindestmenge beträgt {{minimum}}',
    'warning_arrondis': 'Die Menge wurde auf das nächsthöhere Vielfache angepasst (Vielfaches: {{multiple}})',
    'ajout_preco': 'Das Produkt wurde zum Warenkorb vom {{date, datetime}} hinzugefügt',
    'unite_switchee': 'Die Menge hat sich geändert, um <strong>{{quantite}} Pakete</strong> zu ergeben',
    'produit_introuvable_supprime': 'Das Produkt ist nicht auffindbar und kann nicht gelöscht werden.',
    'ajout_nouvelle_liste': 'Die Liste {{newListName}} wurde erstellt',
    'ajout_liste': 'Der Artikel wurde zur Liste hinzugefügt',
    'article_deja_present': 'Dieser Artikel ist bereits in Ihrer Liste vorhanden.',
    'ajout_cadencier': 'Das Produkt wurde zur Bestellvorlage hinzugefügt',
    'ajout_cadencier_simulation': 'Das Produkt wurde nicht wirklich zur Bestellvorlage hinzugefügt',
    'ajout_cadencier_safelive': 'Das Produkt wurde wirklich zur Bestellvorlage hinzugefügt.<br />Damit es nicht berücksichtigt wird, entfernen Sie es sofort aus der Bestellvorlage',
    'panier_deplace': 'Warenkorb verschoben zum <strong>{{date, datetime}}</strong>',
    'panier_vidé': 'Der Warenkorb vom {{date}} wurde geleert',
    'produit_differe': 'Produkt <strong>in den Warenkorb vom {{date}} verschoben.</strong>',
    'produit_differe_cta': 'Vergessen Sie nicht, ihn so schnell wie möglich zu bestätigen.',
    'produit_remplace': 'Produkt durch {{libelle}} ersetzt',
    'voir_panier': 'Warenkorb ansehen',
    'voir_liste': 'Liste ansehen',
    'produit_precommande': 'Achtung, Produkt auf Vorbestellung',
    'quantite_ajustee': 'Die Menge wurde auf {{quantite}} {{unite}} angepasst',
    'donnees_rafraichies': 'Die Kundendaten wurden erfolgreich aktualisiert.',
    'panier_valide_simulation': 'Ihr Warenkorb wurde geprüft, aber nicht wirklich in eine Bestellung in Tolede umgewandelt.',
    'panier_valide_safelive': 'Ihr Warenkorb wurde wirklich in eine Bestellung in Tolede umgewandelt.<br />Damit sie nicht vorbereitet wird, müssen Sie sie sofort stornieren.',
    'prolonge_session': 'Ihre Sitzung wurde erfolgreich verlängert.',
    'prolongement_session_impossible': 'Ihre Sitzung konnte nicht verlängert werden.',
    'clients_rafraichis': 'Die Kundenliste wurde erfolgreich aktualisiert.',
    'cgv_reinitialisees': 'Die AGB-Akzeptanzen wurden für alle Kunden zurückgesetzt.',
    'invitation_envoyee': 'Die Einladung wurde erfolgreich an {{email}} gesendet.',
    'relance_envoyee': 'Die Mahnung wurde erfolgreich an {{email}} gesendet.',
    'ajoute_panier_marketplace': 'Produkt zum Warenkorb {{marketplace}} hinzugefügt'
  },
  'panier': {
    'panier': 'Warenkorb',
    'panier_pdf': 'Warenkorb - PDF-Bestellung',
    'pdf': 'PDF',
    'matching_filtre_tout': 'Alle',
    'matching_filtre_ok': 'Ok: {{nombre}}',
    'matching_filtre_alerte': 'Zu prüfen: {{nombre}}',
    'matching_filtre_bloquant': 'Vorrangig prüfen: {{nombre}}',
    'matching_details': 'Details',
    'matching_remplace': 'Ersetzt',
    'matching_correspondance_initiale': 'Ursprüngliche Übereinstimmung',
    'matching_phrase': {
      'code_exact_libelle_exact': {
        'ok': 'Zeile OK, da Artikel erkannt (Code und Bezeichnung exakt) und Preis exakt.',
        'alerte': 'Zeile zu prüfen wegen einer geringen Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Code und Bezeichnung exakt).',
        'ko': 'Zeile zu prüfen wegen der Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Code und Bezeichnung exakt).',
        'vide': 'Zeile zu prüfen, da der Preis fehlt und nicht verglichen werden konnte. Der Artikel wurde korrekt erkannt (Code und Bezeichnung exakt).'
      },
      'code_exact_libelle_proche': {
        'ok': 'Zeile OK, da Artikel erkannt (Code exakt, aber Bezeichnung nicht vollständig exakt) und Preis exakt.',
        'alerte': 'Zeile zu prüfen wegen einer geringen Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Code exakt, aber Bezeichnung nicht vollständig exakt).',
        'ko': 'Zeile zu prüfen wegen der Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Code exakt, aber Bezeichnung nicht vollständig exakt).',
        'vide': 'Zeile zu prüfen, da der Preis fehlt und nicht verglichen werden konnte. Der Artikel wurde korrekt erkannt (Code exakt, aber Bezeichnung nicht vollständig exakt).'
      },
      'code_exact_libelle_non_reconnu': {
        'ok': 'Zeile zu prüfen: Der Code ist exakt, aber die Bezeichnung wird nicht erkannt, Fehlerrisiko beim Artikel. Der Preis ist exakt.',
        'alerte': 'Zeile zu prüfen: Der Code ist exakt, aber die Bezeichnung wird nicht erkannt, mit einer geringen Preisabweichung ({{ecart}}).',
        'ko': 'Zeile zu prüfen: Der Code ist exakt, aber die Bezeichnung wird nicht erkannt, und der Preis weicht um {{ecart}} ab.',
        'vide': 'Zeile zu prüfen: Der Code ist exakt, aber die Bezeichnung wird nicht erkannt, und der Preis fehlt.'
      },
      'code_different_libelle_exact': {
        'ok': 'Zeile OK, da Artikel erkannt (Bezeichnung exakt, aber Code abweichend) und Preis exakt.',
        'alerte': 'Zeile zu prüfen wegen einer geringen Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Bezeichnung exakt, aber Code abweichend).',
        'ko': 'Zeile zu prüfen wegen der Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Bezeichnung exakt, aber Code abweichend).',
        'vide': 'Zeile zu prüfen, da der Preis fehlt und nicht verglichen werden konnte. Der Artikel wurde korrekt erkannt (Bezeichnung exakt, aber Code abweichend).'
      },
      'code_different_libelle_proche': {
        'ok': 'Zeile zu prüfen, da die Identifizierung unsicher ist (Code abweichend und Bezeichnung nicht vollständig exakt). Der Preis ist exakt.',
        'alerte': 'Zeile zu prüfen, da die Identifizierung unsicher ist (Code abweichend und Bezeichnung nicht vollständig exakt), mit einer geringen Preisabweichung ({{ecart}}).',
        'ko': 'Zeile zu prüfen, da die Identifizierung unsicher ist (Code abweichend und Bezeichnung nicht vollständig exakt), und der Preis weicht um {{ecart}} ab.',
        'vide': 'Zeile zu prüfen, da die Identifizierung unsicher ist (Code abweichend und Bezeichnung nicht vollständig exakt), und der Preis fehlt.'
      },
      'code_different_libelle_non_reconnu': {
        'ok': 'Zeile zu prüfen: Artikel nicht erkannt (weder Code noch Bezeichnung stimmen überein), auch wenn der Preis exakt ist.',
        'alerte': 'Zeile zu prüfen: Artikel nicht erkannt (weder Code noch Bezeichnung stimmen überein), mit einer geringen Preisabweichung ({{ecart}}).',
        'ko': 'Zeile zu prüfen: Artikel nicht erkannt (weder Code noch Bezeichnung stimmen überein) und Preisabweichung ({{ecart}}).',
        'vide': 'Zeile zu prüfen: Artikel nicht erkannt (weder Code noch Bezeichnung stimmen überein) und Preis fehlt.'
      },
      'code_absent_libelle_exact': {
        'ok': 'Zeile OK, da Artikel erkannt (Bezeichnung exakt, kein Code auf dem Bestellschein) und Preis exakt.',
        'alerte': 'Zeile zu prüfen wegen einer geringen Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Bezeichnung exakt, kein Code auf dem Bestellschein).',
        'ko': 'Zeile zu prüfen wegen der Preisabweichung ({{ecart}}). Der Artikel wurde korrekt erkannt (Bezeichnung exakt, kein Code auf dem Bestellschein).',
        'vide': 'Zeile zu prüfen, da der Preis fehlt und nicht verglichen werden konnte. Der Artikel wurde korrekt erkannt (Bezeichnung exakt, kein Code auf dem Bestellschein).'
      },
      'code_absent_libelle_proche': {
        'ok': 'Zeile zu prüfen, da die Identifizierung unsicher ist (kein Code auf dem Bestellschein und Bezeichnung nicht vollständig exakt). Der Preis ist exakt.',
        'alerte': 'Zeile zu prüfen, da die Identifizierung unsicher ist (kein Code auf dem Bestellschein und Bezeichnung nicht vollständig exakt), mit einer geringen Preisabweichung ({{ecart}}).',
        'ko': 'Zeile zu prüfen, da die Identifizierung unsicher ist (kein Code auf dem Bestellschein und Bezeichnung nicht vollständig exakt), und der Preis weicht um {{ecart}} ab.',
        'vide': 'Zeile zu prüfen, da die Identifizierung unsicher ist (kein Code auf dem Bestellschein und Bezeichnung nicht vollständig exakt), und der Preis fehlt.'
      },
      'code_absent_libelle_non_reconnu': {
        'ok': 'Zeile zu prüfen: Artikel nicht erkannt (kein Code auf dem Bestellschein und Bezeichnung nicht erkannt), auch wenn der Preis exakt ist.',
        'alerte': 'Zeile zu prüfen: Artikel nicht erkannt (kein Code auf dem Bestellschein und Bezeichnung nicht erkannt), mit einer geringen Preisabweichung ({{ecart}}).',
        'ko': 'Zeile zu prüfen: Artikel nicht erkannt (kein Code auf dem Bestellschein und Bezeichnung nicht erkannt) und Preisabweichung ({{ecart}}).',
        'vide': 'Zeile zu prüfen: Artikel nicht erkannt (kein Code auf dem Bestellschein und Bezeichnung nicht erkannt) und Preis fehlt.'
      }
    },
    'matching_aucune_correspondance': 'Keine Entsprechung',
    'matching_article_indisponible':
      'Artikel erkannt, aber nicht in den Warenkorb übernommen',
    'matching_ligne_supprimee': 'PDF-Zeile aus dem Warenkorb entfernt',
    'matching_aucune_ligne_filtre': 'Keine Zeile entspricht diesem Filter',
    'matching_resultat_ok': 'OK',
    'matching_resultat_ko': 'Fehler',
    'finaliser_commande': 'Prüfen und abschließen',
    'panier_vide': 'Ihr Warenkorb ist leer',
    'ajouter_au_panier': 'In den Warenkorb',
    'deja_au_panier': 'Bereits im Warenkorb',
    'panier_vide_cta': 'Jetzt bestellen!',
    'panier_vide_cta_mobile': 'Sie können jetzt bestellen',
    'panier_vide_cta_top': 'Vergessen Sie nicht, Ihre offenen Warenkörbe so schnell wie möglich zu bestätigen!',
    'paniers_ouverts': 'offene Warenkörbe',
    'paniers_ouverts_one': 'Offener Warenkorb',
    'paniers_ouverts_other': 'Offene Warenkörbe',
    'livraison_48h_72h': 'Lieferung durch MATFER innerhalb von 48–72 Stunden',
    'livraison_48h_72h_court': 'Lieferung innerhalb von 48–72 Stunden',
    'paniers': 'Warenkorb',
    'paniers_one': 'Warenkorb',
    'paniers_other': 'Warenkörbe',
    'paniers_plural': 'Warenkörbe',
    'paniers_many': 'Warenkörbe',
    'paniers_actifs': 'Aktiver Warenkorb',
    'paniers_actifs_one': 'Aktiver Warenkorb',
    'paniers_actifs_other': 'Aktive Warenkörbe',
    'paniers_actifs_plural': 'Aktive Warenkörbe',
    'paniers_actifs_many': 'Aktive Warenkörbe',
    'paniers_label': 'Warenkörbe',
    'livraison_selectionnee': 'Ausgewählte Lieferung',
    'depuis_cadencier': 'Aus meiner Bestellvorlage',
    'depuis_catalogue': 'Aus dem Katalog',
    'depuis_listes': 'Aus meinen Listen',
    'remplacement_de': 'Ersatz für {{produit}}',
    'pour_la_livraison_du': 'Für die Lieferung am <strong>{{date, datetime}}</strong>',
    'pour_la_livraison_du_mobile': 'Lieferung am <strong>{{date, datetime}}</strong>',
    'nous_validons': 'Wir bestätigen Ihren Warenkorb',
    'menu_tooltip': 'Warenkorb vom {{date}} anzeigen',
    'changer_date': 'Datum ändern',
    'commander_pour_une_autre_date': 'Für ein anderes Datum bestellen',
    'panier_a_valider': 'Meine zu bestätigenden Warenkörbe',
    'x_panier_a_valider': '{{count}} Warenkorb zu bestätigen',
    'x_panier_a_valider_one': '{{count}} Warenkorb zu bestätigen',
    'x_panier_a_valider_other': '{{count}} Warenkörbe zu bestätigen',
    'x_panier_a_valider_plural': '{{count}} Warenkörbe zu bestätigen',
    'liste_livraisons_prompt_mobile': 'Für ein anderes Datum bestellen',
    'supprimer_panier_confirm': 'Möchten Sie den Warenkorb wirklich leeren?',
    'supprimer_panier_action': 'Warenkorb leeren',
    'supprimer_panier_action_mobile': 'Leeren',
    'panier_en_cours': 'Aktueller Warenkorb',
    'commande_existant': 'Für diesen Liefertag existiert bereits eine Bestellung',
    'listes': '{{count}} Liste',
    'listes_one': '{{count}} Liste',
    'listes_other': '{{count}} Listen',
    'listes_plural': '{{count}} Listen',
    'confirmer_adresse_livraison': {
      'titre': 'Lieferadresse bestätigen',
      'bouton_confirmer': 'Ich bestätige',
      'bouton_changer_adresse': 'Adresse ändern'
    },
    'error': {
      'hors_delai': {
        'tolerance': 'Wir leiten diese Bestellung an unsere Dienste weiter, obwohl sie verspätet ist (Bestellschluss: {{heure_a_atteindre}}). Vielen Dank für Ihre Wachsamkeit bei zukünftigen Bestellungen.',
        'surcout': 'Diese Bestellung ist verspätet (Bestellschluss: {{heure_a_atteindre}}). Es wird ein Aufpreis von {{surcout_a_valider}} Euro erhoben.',
        'bloquant': 'Die Bestellzeit überschreitet die maximal akzeptable Frist (Bestellschluss: {{heure_a_atteindre}}).'
      },
      'franco': {
        'tolerance': {
          'montant_a_atteindre': 'Wir leiten diese Bestellung an unsere Dienste weiter, obwohl sie den Mindestbestellwert nicht erreicht (Mindestbestellwert: {{montant_a_atteindre}} Euro). Vielen Dank für Ihre Wachsamkeit bei zukünftigen Bestellungen.',
          'poids_a_atteindre': 'Wir leiten diese Bestellung an unsere Dienste weiter, obwohl sie das Mindestgewicht nicht erreicht (Mindestbestellgewicht: {{poids_a_atteindre}} kg). Vielen Dank für Ihre Wachsamkeit bei zukünftigen Bestellungen.',
          'montant_a_atteindre_et_poids_a_atteindre': 'Wir leiten diese Bestellung an unsere Dienste weiter, obwohl sie den Mindestbestellwert und das Mindestgewicht nicht erreicht (Mindestbestellwert: {{montant_a_atteindre}} Euro, {{poids_a_atteindre}} kg). Vielen Dank für Ihre Wachsamkeit bei zukünftigen Bestellungen.'
        },
        'surcout': {
          'montant_a_atteindre': 'Diese Bestellung erreicht nicht den Mindestbestellwert (Mindestbestellwert: {{montant_a_atteindre}} Euro). Es wird ein Aufpreis von {{surcout_a_valider}} Euro erhoben.',
          'poids_a_atteindre': 'Diese Bestellung erreicht nicht das Mindestbestellgewicht (Mindestbestellgewicht: {{poids_a_atteindre}} kg). Es wird ein Aufpreis von {{surcout_a_valider}} Euro erhoben.',
          'montant_a_atteindre_et_poids_a_atteindre': 'Diese Bestellung erreicht nicht den Mindestbestellwert und das Mindestgewicht (Mindestbestellwert: {{montant_a_atteindre}} Euro, {{poids_a_atteindre}} kg). Es wird ein Aufpreis von {{surcout_a_valider}} Euro erhoben.'
        },
        'bloquant': {
          'montant_a_atteindre': 'Diese Bestellung erreicht nicht den Mindestbestellwert (Mindestbestellwert: {{montant_a_atteindre}} Euro).',
          'poids_a_atteindre': 'Diese Bestellung erreicht nicht das Mindestbestellgewicht (Mindestbestellgewicht: {{poids_a_atteindre}} kg).',
          'montant_a_atteindre_et_poids_a_atteindre': 'Diese Bestellung erreicht nicht den Mindestbestellwert und das Mindestgewicht (Mindestbestellwert: {{montant_a_atteindre}} Euro, {{poids_a_atteindre}} kg).'
        }
      }
    },
    'vide': {
      'votre_panier_est_vide': 'Ihr Warenkorb ist leer.',
      'merci': 'Vielen Dank',
      'pour_votre_commande': 'für Ihre Bestellung!',
      'vous_allez_recevoir_email': 'Sie erhalten in wenigen Augenblicken eine Bestätigungs-E-Mail.',
      'consulter_detail_commande': 'Sie können die Details Ihrer Bestellung jederzeit im Bereich "Meine Bestellungen" einsehen.',
      'pour_toute_question': 'Bei Fragen zu Ihrer Bestellung bitten wir Sie, Ihren Berater zu kontaktieren.',
      'vous_avez_x_panier': 'Sie haben {{count}} Warenkorb zu bestätigen.',
      'vous_avez_x_panier_one': 'Sie haben {{count}} Warenkorb zu bestätigen.',
      'vous_avez_x_panier_other': 'Sie haben {{count}} Warenkörbe zu bestätigen.',
      'vous_avez_x_panier_plural': 'Sie haben {{count}} Warenkörbe zu bestätigen.',
      'validez_pour_reserver': 'Bestätigen Sie Ihre offenen Warenkörbe, um Ihre Bestände zu reservieren.',
      'n_oubliez_pas_de_valider_restant': 'Vergessen Sie nicht, Ihren<br/>verbleibenden Warenkorb zu bestätigen',
      'n_oubliez_pas_de_valider_restant_one': 'Vergessen Sie nicht, Ihren<br/>verbleibenden Warenkorb zu bestätigen',
      'n_oubliez_pas_de_valider_restant_other': 'Vergessen Sie nicht, Ihre<br/>verbleibenden Warenkörbe zu bestätigen',
      'n_oubliez_pas_de_valider_restant_many': 'Vergessen Sie nicht, Ihre<br/>verbleibenden Warenkörbe zu bestätigen',
      'n_oubliez_pas_de_valider_restant_plural': 'Vergessen Sie nicht, Ihre<br/>verbleibenden Warenkörbe zu bestätigen',
      'prenez_de_lavance': 'Seien Sie voraus!',
      'preparez_prochaine_livraison': 'Bereiten Sie jetzt Ihre nächste Lieferung vor',
      'alt_carton_vide': 'Leerer Bestellkarton'
    },
    'recap': {
      'recapitulatif': 'Zusammenfassung',
      'valider_le_panier': 'Warenkorb bestätigen',
      'valider_mon_panier': 'Meinen Warenkorb bestätigen',
      'valider_et_payer': 'Warenkorb bestätigen und bezahlen',
      'total_ht': 'Gesamt Netto',
      'surcout_ht': 'Zuschlag Netto',
      'total_tva': 'Gesamt MwSt.',
      'total_ttc': 'Gesamt Brutto',
      'tooltip_total_ht': 'Geschätzter Betrag basierend auf den bestellten Mengen, der bei der Lieferung angepasst wird',
      'statut_tolede': 'Tolede-Status',
      'commande_impossible': 'Die Bestellung ist nicht möglich',
      'motif_blocage_non_precise': 'Grund nicht angegeben',
      'accepter_conditions': 'Ich akzeptiere die <Link>Allgemeinen Geschäftsbedingungen</Link>',
      'mode_de_rendu': {
        'enlevement': 'Abholung im Lager',
        'livraison': 'Lieferung',
        'presta_direct': 'Lieferung'
      },
      'modale_adresse': {
        'titre_enlevement': 'Holen Sie Ihre Bestellung in Ihrem Lager ab',
        'titre_livraison': 'Lieferung'
      },
      'reference_commande': 'Bestellreferenz',
      'reference_commande_needed': 'Bestellreferenz (obligatorisch)*',
      'commentaire_commande': 'Kommentar',
      'commentaire_commande_placeholder': 'Fügen Sie einen Kommentar zu Ihrer Bestellung hinzu...',
      'marketplace_livraison_titre': 'Service + Lieferung',
      'marketplace_livraison_delai': 'Lieferung durch MATFER innerhalb von 48h bis 72h',
      'option_de_paiement': 'Zahlungsoption',
      'paiement_par_carte_bancaire': 'Zahlung per Kreditkarte',
      'tooltip_paiement': 'Wenn Sie andere Zahlungsmethoden nutzen möchten, wenden Sie sich bitte an Ihren Handelsvertreter',
    },
    'validez': {
      'plus_de_2_jours': 'Bestätigen Sie Ihren Warenkorb, um die Mengen zu sichern.',
      'moins_de_2_jours': 'Nur noch <strong>{{date}}</strong>, um zum gewählten Datum geliefert zu werden.'
    },
    'paiement': {
      'traitement_en_cours': 'Zahlung wird verarbeitet...',
      'ne_pas_fermer': 'Bitte schließen Sie diese Seite nicht.',
      'erreur_initiation': 'Zahlung konnte nicht eingeleitet werden. Bitte versuchen Sie es erneut.',
      'retour_panier': 'Zurück zum Warenkorb',
      'transaction_echouee': 'Die Transaktion konnte nicht abgeschlossen werden',
      'redirection_panier': 'Sie werden zum Warenkorb weitergeleitet',
    },
    'quantites_inhabituelles': {
      'titre': 'Ungewöhnliche Mengen',
      'message': 'Die Mengen dieser Produkte sind ungewöhnlich:',
      'message_one': 'Die Menge dieses Produkts ist ungewöhnlich:',
      'message_other': 'Die Mengen dieser Produkte sind ungewöhnlich:',
      'message_plural': 'Die Mengen dieser Produkte sind ungewöhnlich:',
      'message_suite': 'Möchten Sie Ihre Bestellung bestätigen oder diese Mengen ändern?',
      'modifier': 'Ändern',
      'valider': 'Bestätigen'
    },
    'paniers_label_one': 'Warenkorb',
    'paniers_label_other': 'Warenkörbe',
    'paniers_label_plural': 'Warenkörbe',
    'paniers_label_many': 'Warenkörbe'
  },
  'bouton_achat': {
    'buy': 'Hinzufügen',
    'buy_court': 'Hinzufügen',
    'ajouter_au_devis': 'Zum Angebot hinzufügen',
    'produit_ajoute_au_devis': 'Produkt hinzugefügt',
    'preco': 'Vorbestellen'
  },
  'ligne_produit': {
    'promotion_non_applicable':
      'Die Aktion gilt nicht für das gewählte Lieferdatum',
    'soit_prix': 'd.h. {{prix}}€',
    'retirer_le_produit': 'Entfernen',
    'poids_variable': 'Variables Gewicht',
    'poids_variable_label': 'Das Produkt wird nach tatsächlichem Gewicht berechnet',
    'tva_percent': 'MwSt. {{tauxTVA}}%',
    'HT': 'netto',
    'TTC': 'brutto',
    'encart_dlc': 'Geschätztes MHD: <strong>{{date}}</strong>',
    'encart_dlc_tooltip': 'MHD des Tages für eine Zubereitung am selben Tag',
    'afficher_dlc_stock': 'MHD und Lagerbestand anzeigen',
    'indisponible': {
      'rupture_partielle': 'Nur <strong>{{quantite_max}}</strong> ist verfügbar <i>(angeforderte Menge: {{quantite_demande}})</i>',
      'rupture_partielle_one': 'Nur <strong>{{quantite_max}}</strong> ist verfügbar <i>(angeforderte Menge: {{quantite_demande}})</i>',
      'rupture_partielle_other': 'Nur <strong>{{quantite_max}}</strong> sind verfügbar <i>(angeforderte Menge: {{quantite_demande}})</i>',
      'rupture_partielle_plural': 'Nur <strong>{{quantite_max}}</strong> sind verfügbar <i>(angeforderte Menge: {{quantite_demande}})</i>',
      'rupture': 'Nicht vorrätig ({{quantite}} {{unite}} im Warenkorb)',
      'delai_de_prepa_long': 'Dieser Artikel kann für diese Lieferung nicht rechtzeitig vorbereitet werden.',
      'delai_de_prepa_long_avec_date': 'Dieser Artikel kann für diese Lieferung nicht rechtzeitig vorbereitet werden. Nächstes mögliches Datum: <strong>{{date}}</strong>.',
      'generique': 'Ein Problem verhindert die Bestellung dieses Artikels.',
      'date_dispo': 'Verfügbar ab <strong>{{date}}</strong>',
      'remplacer': 'Ersetzen',
      'differer': 'Aufschieben',
      'differer_livraison': 'Lieferung verschieben',
      'ajuster_quantite': 'Menge auf {{quantite}} {{unite}} anpassen',
      'ajuster_quantite_court': 'Menge anpassen',
      'tooltip_ajuster_quantite': 'Auf {{quantite}} {{unite}} im Warenkorb anpassen',
      'tooltip_rupture_totale': 'Aus dem Warenkorb entfernen',
      'entete': '<strong>{{count}} Produkt</strong> ist für den <strong>{{dateDeLivraison}}</strong> nicht verfügbar',
      'entete_one': '<strong>{{count}} Produkt</strong> ist für den <strong>{{dateDeLivraison}}</strong> nicht verfügbar',
      'entete_other': '<strong>{{count}} Produkte</strong> sind für den <strong>{{dateDeLivraison}}</strong> nicht verfügbar',
      'entete_plural': '<strong>{{count}} Produkte</strong> sind für den <strong>{{dateDeLivraison}}</strong> nicht verfügbar',
      'entete_no_date': '<strong>{{count}} Produkt</strong> ist nicht verfügbar',
      'entete_no_date_one': '<strong>{{count}} Produkt</strong> ist nicht verfügbar',
      'entete_no_date_other': '<strong>{{count}} Produkte</strong> sind nicht verfügbar',
      'entete_no_date_plural': '<strong>{{count}} Produkte</strong> sind nicht verfügbar',
      'produit_indisponible': 'Produkt für den {{dateDeLivraison}} nicht verfügbar',
      'produit_indisponible_short': 'Produkt nicht verfügbar',
      'article_indisponible': 'Artikel nicht verfügbar',
    }
  },
  'disponibilite': {
    'precommande': 'Vorbestellung',
    'a_partir': 'Ab dem {{date}}'
  },
  'modale_livraison': {
    'header': {
      'selection_periode': 'Wählen Sie einen Lieferzeitraum',
      'preco': 'Wählen Sie Ihr Lieferdatum',
      'changement_panier': 'Lieferdatum ändern',
      'default': 'Lieferdatum ändern',
      'ouvrir': 'Einen Warenkorb für ein anderes Datum öffnen'
    },
    'preco': {
      'title': 'Produkt auf Vorbestellung',
      'info': 'Dieses Produkt ist erst ab den unten genannten Daten verfügbar.',
      'date': 'Verfügbare Daten nach dem {{dateDebut, datetime}}:'
    },
    'legende': {
      'jour_selectionne': 'Ausgewählter Liefertag',
      'panier_en_cours': 'Aktueller Warenkorb',
      'panier_valide': 'Bestätigter Warenkorb'
    },
    'changer_date': 'Dieses Datum auswählen',
    'valider_date': 'Lieferdatum bestätigen',
    'afficher_plus': 'Mehr Daten anzeigen',
    'nous-requetons-les-disponibilites-de-larticle': 'Wir fragen die Verfügbarkeiten des Artikels ab'
  },
  'erreur404': {
    'alt_img_carton': 'leerer Karton, auf dessen Boden "Uups!" steht',
    'c_est_bien_vide_ici': 'Hmm... Hier ist es ziemlich leer',
    'pas_de_panique': 'Keine Panik, hier entlang, um ihn zu füllen:',
    'voir_cadencier': 'Meine Bestellvorlage ansehen',
    'voir_catalogue': 'Katalog ansehen',
    'retour_accueil': 'Zurück zur Startseite'
  },
  'backoffice_erreur404': {
    'alt_img_carton': 'leerer Karton, auf dessen Boden "Uups!" steht',
    'page_introuvable': 'Seite nicht gefunden',
    'verifier_url': 'Diese Seite existiert nicht oder existiert nicht mehr. Überprüfen Sie die URL oder kehren Sie zur FFcommerce-Startseite zurück.',
    'retour_backoffice': 'Zurück zur Startseite'
  },
  'error': {
    'introuvable_en_db': 'Das Objekt wurde in der Datenbank nicht gefunden.',
    'cgv_requise': 'Die Annahme der Allgemeinen Geschäftsbedingungen ist erforderlich.',
    'echec_call_api': 'Ein Fehler ist aufgetreten.',
    'item_catalogue_introuvable': 'Artikel im Katalog nicht gefunden.',
    'article_introuvable': 'Artikel in der Datenbank nicht gefunden.',
    'quantite_invalide': 'Die Menge ist kein Vielfaches der Kundenbestellung.',
    'code_adresse_de_livraison_inconnu': 'Diese Lieferadresse existiert nicht für diesen Kunden.',
    'livraison_introuvable': 'Keine Lieferung für dieses Datum und diesen Kunden.',
    'quantite_en_colis_indisponible': 'Die Menge in Paketen ist für diesen Artikel nicht verfügbar.',
    'unite_deja_selectionnee': 'Die angeforderte Einheit ist bereits ausgewählt.',
    'prix_a_zero': 'Der Katalogpreis für diesen Artikel ist nicht angegeben.',
    'label_asset_introuvable': 'Das Laden eines Bildes ist fehlgeschlagen.',
    'probleme_bloquant_sur_commande': 'Die Speicherung der Bestellung ist fehlgeschlagen, überprüfen Sie Ihren Warenkorb.',
    'article_deja_present_dans_le_panier': 'Der Artikel ist bereits im Warenkorb der Ziellieferung vorhanden.',
    'article_deja_present_dans_le_devis': 'Der Artikel ist bereits im Angebot enthalten.',
    'changement_mode_de_rendu_impossible': 'Es ist nicht möglich, die Abhol-/Lieferart für diese Lieferung zu ändern.',
    'doublon_liste': 'Das Produkt ist bereits in dieser Liste vorhanden.',
    'quantite_max_depassee': 'Menge für das Produkt <strong>{{libelle}}</strong> nicht ausreichend auf Lager<br />Maximal bestellbar: <strong>{{max}} {{unite}}</strong>.',
    'article_inconnu': 'Informationen zum Artikel nicht gefunden.',
    'medias_non_touves': 'Problem beim Abrufen der mit dem Artikel verknüpften Medien.',
    'panier_introuvable_en_db': 'Dieser Warenkorb ist nicht auffindbar,<br /><strong><Reload>bitte laden Sie Ihre Seite neu.</Reload></strong>.',
    'ligne_de_panier_introuvable_en_db': 'Diese Warenkorbzeile ist nicht auffindbar,<br /><strong><Reload>bitte laden Sie Ihre Seite neu.</Reload></strong>.',
    'panier_tolede_mode_desactive': 'Die Umwandlung eines Warenkorbs in eine Tolede-Bestellung ist nicht zulässig.',
    'cadencier_tolede_mode_desactive': 'Aktionen in der Bestellvorlage sind nicht zulässig.',
    'colis_ajuste': 'Die Menge wurde auf das nächstgelegene Paket angepasst.',
    'controle_panier': 'Bei der Bestätigung des Warenkorbs ist ein Fehler aufgetreten.<br />Bitte versuchen Sie es später erneut.',
    'commande_panier': 'Der Warenkorb konnte nicht bestätigt werden, bitte versuchen Sie es später erneut.<br /><Contact>Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte</Contact>.',
    'controle_dispo': 'Wir konnten die Verfügbarkeit des Artikels nicht überprüfen.<br />Bitte versuchen Sie es später erneut.',
    'client_bloque': 'Sie können von diesem Konto aus keine Bestellung aufgeben, <Contact>bitte kontaktieren Sie uns.</Contact>.',
    'generique': 'Ein Fehler in der Bestellung verhindert deren Bearbeitung.',
    'quantite_trop_importante': 'Zu große Menge für ein oder mehrere Produkte.',
    'rupture': 'Das Produkt {{libelle}} ist nicht vorrätig.',
    'erreur_date_livraison': 'Das Lieferdatum liegt vor dem aktuellen Datum. Ändern Sie das Datum Ihrer Bestellung.',
    'delai_livraison_trop_long_cb': 'Die Kartenzahlung ist nur für Lieferungen innerhalb der nächsten 6 Tage verfügbar.',
    'panier_sans_ligne': 'Der Warenkorb enthält keine Produkte.',
    'commande_deja_validee': 'Diese Bestellung wurde bereits validiert.',
    'client_inconnu': 'Unbekannter Kunde.',
    'erreur_nb_lignes': 'Falsche Anzahl von Zeilen.',
    'adresse_inconnue': 'Unbekannte Lieferadresse.',
    'erreur_code_tournee': 'Falscher Tourencode.',
    'erreur_mode_de_rendu': 'Falscher Liefertyp.',
    'non_autorise': 'Artikel nicht im Kundenkatalog.',
    'article_obsolete': 'Der Artikel ist veraltet.',
    'non_commercialise': 'Der Artikel wird nicht vertrieben.',
    'non_web': 'Der Artikel ist nicht online bestellbar.',
    'erreur_temperature_tournee': 'Artikel für diese Tour (Temperatur) nicht zulässig.',
    'erreur_multiple_de_commande': 'Falsches Bestellvielfaches.',
    'heure_depassee': 'Bestellschluss überschritten.',
    'delai_de_prepa_long': 'Dieser Artikel kann für diese Lieferung nicht rechtzeitig vorbereitet werden.',
    'reference': 'Bestellreferenz fehlt oder ist ungültig.',
    'prix_plancher': 'Preis unter dem Mindestpreis.',
    'deja_au_cadencier': 'Der Artikel ist bereits in der Bestellvorlage vorhanden.',
    'erreur_cadencier': 'Die Änderung der Bestellvorlage wurde abgelehnt.',
    'cadencier_desactive': 'Das Hinzufügen zur Bestellvorlage ist vorübergehend deaktiviert.',
    "la valeur d'une clé dupliquée rompt la contrainte unique « liste_selection_pkey »": '$t(error.doublon_liste)',
    'duplicate key value violates unique constraint "liste_selection_pkey"': '$t(error.doublon_liste)',
    'dispo': {
      'erreur_generique': 'Ein Fehler bezüglich der Verfügbarkeit des Artikels ist aufgetreten. Überprüfen Sie Ihren Warenkorb.',
      'erreur_quantite_insuffisante': 'Nicht genügend Lagerbestand für diesen Artikel. Überprüfen Sie Ihren Warenkorb.'
    },
    'date_differer_manquante': 'Fehler: Das Datum der nächsten Lieferung für diesen Artikel wurde nicht mitgeteilt',
    'rupture_article': 'Die gewünschte Menge für Ihren Artikel ist nicht verfügbar.',
    'no_client': 'Kein Kunde für diese Vertriebsgesellschaft.',
    'no_tournee': 'Keine geplante Liefertour für diese Vertriebsgesellschaft.',
    'unknown': 'Bei der Suche ist ein Fehler aufgetreten. Bitte versuchen Sie es in einigen Augenblicken erneut.',
    'index.building': 'Die Vorbereitung des Suchindex ist im Gange. Bitte versuchen Sie es in einigen Augenblicken erneut.',
    'index.building_started': 'Wir bereiten gerade den Suchindex vor. Bitte versuchen Sie es in wenigen Minuten erneut.',
    'index.build_failed': 'Der Suchindex konnte nicht vorbereitet werden. Bitte kontaktieren Sie den Support.',
    'panier_pas_en_attente_paiement': 'Der Warenkorb wartet nicht auf Zahlung.',
    'paiement_non_confirme': 'Die Zahlung wurde nicht bestätigt. Bitte versuchen Sie es erneut.',
    'catalogue_grand_compte_unauthorized': 'Zugriff verweigert. Sie haben keinen Zugriff auf den vollständigen Katalog.',
    'tooltip_generique_details': '{{message}} ({{code}})'
  },
  'unite': {
    'B': 'Flasche',
    'B_one': 'Flasche',
    'B_other': 'Flaschen',
    'B_many': '$t(unite.B_other)',
    'B_plural': '$t(unite.B_other)',
    'BA': 'Schale',
    'BA_one': 'Schale',
    'BA_other': 'Schalen',
    'BA_many': '$t(unite.BA_other)',
    'BA_plural': '$t(unite.BA_other)',
    'BB': 'Glas',
    'BB_one': 'Glas',
    'BB_other': 'Gläser',
    'BB_many': '$t(unite.BB_other)',
    'BB_plural': '$t(unite.BB_other)',
    'BC': 'Wanne',
    'BC_one': 'Wanne',
    'BC_other': 'Wannen',
    'BC_many': '$t(unite.BC_other)',
    'BC_plural': '$t(unite.BC_other)',
    'BI': 'Kanister',
    'BI_one': 'Kanister',
    'BI_other': 'Kanister',
    'BI_many': '$t(unite.BI_other)',
    'BI_plural': '$t(unite.BI_other)',
    'BO': 'Korb',
    'BO_one': 'Korb',
    'BO_other': 'Körbe',
    'BO_many': '$t(unite.BO_other)',
    'BO_plural': '$t(unite.BO_other)',
    'BT': 'Dose',
    'BT_one': 'Dose',
    'BT_other': 'Dosen',
    'BT_many': '$t(unite.BT_other)',
    'BT_plural': '$t(unite.BT_other)',
    'BX': 'Box',
    'BX_one': 'Box',
    'BX_other': 'Boxen',
    'BX_many': '$t(unite.BX_other)',
    'BX_plural': '$t(unite.BX_other)',
    'C1': 'C1',
    'C1_one': 'C1',
    'C1_other': 'C1',
    'C1_many': '$t(unite.C1_other)',
    'C1_plural': '$t(unite.C1_other)',
    'C2': 'C2',
    'C2_one': 'C2',
    'C2_other': 'C2',
    'C2_many': '$t(unite.C2_other)',
    'C2_plural': '$t(unite.C2_other)',
    'CA': 'Karton',
    'CA_one': 'Karton',
    'CA_other': 'Kartons',
    'CA_many': '$t(unite.CA_other)',
    'CA_plural': '$t(unite.CA_other)',
    'CI': 'Kistchen',
    'CI_one': 'Kistchen',
    'CI_other': 'Kistchen',
    'CI_many': '$t(unite.CI_other)',
    'CI_plural': '$t(unite.CI_other)',
    'CN': 'CN',
    'CN_one': 'CN',
    'CN_other': 'CN',
    'CN_many': '$t(unite.CN_other)',
    'CN_plural': '$t(unite.CN_other)',
    'CO': 'Paket',
    'CO_one': 'Paket',
    'CO_other': 'Pakete',
    'CO_many': '$t(unite.CO_other)',
    'CO_plural': '$t(unite.CO_other)',
    'CT': 'Hundert',
    'CT_one': 'Hundert',
    'CT_other': 'Hundert',
    'CT_many': '$t(unite.CT_other)',
    'CT_plural': '$t(unite.CT_other)',
    'FU': 'Fass',
    'FU_one': 'Fass',
    'FU_other': 'Fässer',
    'FU_many': '$t(unite.FU_other)',
    'FU_plural': '$t(unite.FU_other)',
    'KG': 'kg',
    'KG_one': 'kg',
    'KG_other': 'kg',
    'KG_many': '$t(unite.KG_other)',
    'KG_plural': '$t(unite.KG_other)',
    'L': 'Liter',
    'L_one': 'Liter',
    'L_other': 'Liter',
    'L_many': '$t(unite.L_other)',
    'L_plural': '$t(unite.L_other)',
    'LO': 'Los',
    'LO_one': 'Los',
    'LO_other': 'Lose',
    'LO_many': '$t(unite.LO_other)',
    'LO_plural': '$t(unite.LO_other)',
    'MI': 'Tausend',
    'MI_one': 'Tausend',
    'MI_other': 'Tausend',
    'MI_many': '$t(unite.MI_other)',
    'MI_plural': '$t(unite.MI_other)',
    'PI': 'Stück',
    'PI_one': 'Stück',
    'PI_other': 'Stücke',
    'PI_many': '$t(unite.PI_other)',
    'PI_plural': '$t(unite.PI_other)',
    'PO': 'Portion',
    'PO_one': 'Portion',
    'PO_other': 'Portionen',
    'PO_many': '$t(unite.PO_other)',
    'PO_plural': '$t(unite.PO_other)',
    'PT': 'Tablett',
    'PT_one': 'Tablett',
    'PT_other': 'Tabletts',
    'PT_many': '$t(unite.PT_other)',
    'PT_plural': '$t(unite.PT_other)',
    'SA': 'Sack',
    'SA_one': 'Sack',
    'SA_other': 'Säcke',
    'SA_many': '$t(unite.SA_other)',
    'SA_plural': '$t(unite.SA_other)',
    'SO': 'Eimer',
    'SO_one': 'Eimer',
    'SO_other': 'Eimer',
    'SO_many': '$t(unite.SO_other)',
    'SO_plural': '$t(unite.SO_other)',
    'SC': 'Sack',
    'SC_one': 'Sack',
    'SC_other': 'Säcke',
    'SC_many': '$t(unite.SA_other)',
    'SC_plural': '$t(unite.SA_other)',
    'colis': 'Paket',
    'colis_one': 'Paket',
    'colis_other': 'Pakete',
    'colis_many': '$t(unite.colis_other)',
    'colis_plural': '$t(unite.colis_other)'
  },
  'month': {
    '1': 'Januar',
    '2': 'Februar',
    '3': 'März',
    '4': 'April',
    '5': 'Mai',
    '6': 'Juni',
    '7': 'Juli',
    '8': 'August',
    '9': 'September',
    '10': 'Oktober',
    '11': 'November',
    '12': 'Dezember'
  },
  'countries': {
    'FR': 'Frankreich',
    'ES': 'Spanien',
    'IT': 'Italien',
    'DE': 'Deutschland',
    'GB': 'Vereinigtes Königreich',
    'US': 'Vereinigte Staaten',
    'CN': 'China',
    'IN': 'Indien',
    'JP': 'Japan',
    'BR': 'Brasilien',
    'RU': 'Russland',
    'CA': 'Kanada',
    'AU': 'Australien',
    'KR': 'Südkorea',
    'MX': 'Mexiko',
    'ID': 'Indonesien',
    'TR': 'Türkei',
    'NL': 'Niederlande',
    'SA': 'Saudi-Arabien',
    'CH': 'Schweiz',
    'PL': 'Polen',
    'SE': 'Schweden',
    'BE': 'Belgien',
    'AR': 'Argentinien',
    'TH': 'Thailand',
    'AT': 'Österreich',
    'NO': 'Norwegen',
    'IR': 'Iran',
    'ZA': 'Südafrika',
    'DK': 'Dänemark',
    'SG': 'Singapur',
    'MY': 'Malaysia',
    'CL': 'Chile',
    'UA': 'Ukraine',
    'SK': 'Slowakei',
    'BG': 'Bulgarien',
    'EE': 'Estland',
    'LT': 'Litauen',
    'NZ': 'Neuseeland',
    'LV': 'Lettland',
    'CZ': 'Tschechische Republik',
    'IS': 'Island',
    'RO': 'Rumänien',
    'HR': 'Kroatien',
    'MT': 'Malta',
    'HU': 'Ungarn',
    'CY': 'Zypern',
    'SI': 'Slowenien',
    'PT': 'Portugal',
    'IE': 'Irland',
    'GR': 'Griechenland',
    'FI': 'Finnland',
    'LU': 'Luxemburg',
    'MA': 'Marokko',
    'BQ': 'Karibische Niederlande',
    'IO': 'Britisches Territorium im Indischen Ozean',
    'EG': 'Ägypten',
    'BD': 'Bangladesch',
    'MG': 'Madagaskar',
    'BA': 'Bosnien und Herzegowina',
    'VN': 'Vietnam',
    'PE': 'Peru',
    'CI': 'Elfenbeinküste',
    'GL': 'Grönland',
    'LI': 'Liechtenstein',
    'AM': 'Armenien',
    'MN': 'Mongolei',
    'MD': 'Moldawien',
    'UY': 'Uruguay',
    'RS': 'Serbien',
    'GE': 'Georgien',
    'FO': 'Färöer-Inseln',
    'GP': 'Guadeloupe',
    'PH': 'Philippinen',
    'BO': 'Bolivien',
    'TN': 'Tunesien',
    'MU': 'Mauritius'
  },
  'menu': {
    'compte': 'Mein Konto',
    'informations': 'Meine Informationen',
    'commandes': 'Meine Bestellungen',
    'factures_et_avoirs': 'Meine Rechnungen',
    'bons_de_livraison': 'Meine Lieferscheine',
    'preferences': 'Meine Einstellungen',
    'changer_de_client': 'Kunde wechseln',
    'deconnecter': 'Abmelden',
    'contacts': 'Meine Kontakte',
    'passer_commande': 'Bestellen',
    'mes_droits': 'Meine Rechte',
    'mes_droits_synako': 'Handelsvertreter-Auswahl',
    'commandes_passees': 'Meine vergangenen Bestellungen',
    'egalim': 'Mein ÉGalim',
  },
  'egalim': {
    'titre': 'Mein ÉGalim-Dashboard',
    'synthese_titre': 'ÉGalim-Einkaufsübersicht',
    'montant_total': 'Gesamt',
    'montant_euro': '{{montant}}€',
    'dont_bio': 'davon Bio',
    'dont_egalim': 'davon ÉGalim',
    'sur_montant_achat': 'von {{montant}}€ Einkäufe',
    'bio': 'Bio',
    'pourcentage_bio': '{{pourcentage}}% (Bio)',
    'pourcentage_egalim': '{{pourcentage}}% (ÉGalim)',
    'egalim': 'ÉGalim',
    'labels_officiels': 'Offizielle ÉGalim-Labels',
    'labels_eligibles': 'Berechtigte Labels',
    'labels_eligibles_info':
      'Diese von manchen Verwaltungen als „berechtigt“ anerkannten Labels werden vom Kunden ausgewählt, der entscheidet, ob er sie in seine Statistik einbezieht oder nicht',
    'labels_eligibles_selectionnes': 'Ausgewählte berechtigte Labels',
    'aucun': 'keine',
    'poids_kg': '{{poids}} Kg',
    'details_par_label': 'Einkaufsdetails nach Label',
    'exporter': 'Meine ÉGalim-Übersicht exportieren (.xls)',
    'periode_debut': 'Beginn',
    'periode_fin': 'Ende',
    'selection_periode': 'Zeitraum auswählen',
    'redirection_web': 'Finden Sie alle Ihre ÉGalim-Indikatoren direkt in der Webversion von France Frais Connect:\n\u2022 Sehen Sie Ihre BIO- und ÉGalim-Quoten in Echtzeit\n\u2022 Prüfen Sie die Details nach Label (Bio, Label Rouge, AOP…)\n\u2022 Exportieren Sie Ihre ÉGalim-Übersicht als .xls\n\u2022 Greifen Sie auf Ihre Einkaufs- und Mengenhistorie nach Zeitraum zu\n\nUm alle Funktionen zu nutzen, melden Sie sich von einem Computer an der üblichen France Frais Connect-Adresse an und öffnen Sie die Rubrik « Mon ÉGalim ».',
    'redirection_web_illustrations': 'Hier sind einige Beispiele, was Sie im Web in Ihrer Rubrik « Mon ÉGalim » finden können:',
    'montant_achat_total': 'Gesamtbetrag',
  },
  'menu_livraison': {
    'tooltip': 'Klicken Sie hier, um für ein anderes Datum zu bestellen.',
    'livraison': 'Lieferung am <strong>{{date}}</strong>'
  },
  'bon_de_livraison': {
    'numero_de_commande': 'Bestellnummer',
    'date_de_commande': 'Bestelldatum',
    'total_de_commande': 'Gesamtbetrag der Bestellung',
    'bon_de_livraison_titre': 'Lieferschein',
    'commande': 'Bestellung',
    'action': 'Aktion',
    'telecharger': 'Herunterladen',
    'telecharger_tout': 'Alle herunterladen',
    'bon_de_livraison': '{{count}} LIEFERSCHEIN',
    'bon_de_livraison_one': '{{count}} LIEFERSCHEIN',
    'bon_de_livraison_other': '{{count}} LIEFERSCHEINE',
    'bon_de_livraison_many': '{{count}} LIEFERSCHEINE',
    'bon_de_livraison_plural': '{{count}} LIEFERSCHEINE',
    '2_derniers_mois': 'Die letzten 2 Monate',
    '3_6_mois': '3 bis 6 Monate',
    'N°': 'Nr.',
    'aucun_bon_de_livraison': 'Sie haben keine Lieferscheine in diesem Zeitraum.'
  },
  'liste': {
    'mois': {
      'tout': 'Alle'
    },
    'date_range': {
      'select': 'Zeitraum',
      'selection': '',
      'debut': 'Startdatum',
      'fin': 'Enddatum',
      'effacer': 'Löschen',
      'valider': 'Bestätigen',
      'changer': 'Ändern'
    },
    'par_periode': 'Nach Zeitraum',
    'categorie': 'Kategorie',
    'frequence_achat': 'Kaufhäufigkeit',
    'filtre': {
      'selection_date': 'Einen Zeitraum auswählen',
      'date_debut': 'Startdatum',
      'date_fin': 'Enddatum',
      'appliquer': 'Anwenden',
      'reinitialiser': 'Zurücksetzen'
    },
    'mes_listes': 'Listen',
    'produits_par_saison': 'Meine Produkte nach Saison',
    'offre_commercial': 'Das Angebot meines Vertriebsmitarbeiters',
    'operation_commerciale': {
      'titre': 'Im Moment',
      'aucune': 'Derzeit keine kommerziellen Aktionen'
    },
    'devis_personnalise': {
      'titre': 'Verkaufsangebot',
      'selection_commercial': 'Auswahl vorbereitet von Ihrem Vertriebsmitarbeiter',
      'selection_commercial_avec_nom': 'Auswahl vorbereitet von {{prenom}} {{nom}}',
      'aucun_devis': 'Kein Verkaufsangebot verfügbar',
      'note_commercial': 'Notiz Ihres Vertriebsmitarbeiters',
      'mis_a_jour_le': 'Aktualisiert am {{date}}',
      'voir_devis': 'Verkaufsangebot ansehen',
      'euro_ht': '€ ohne MwSt./',
      'votre_commercial': 'Ihr Vertriebsmitarbeiter',
      'vous': 'Sie',
      'commentaires': 'Nachrichten',
      'ecrire_commentaire': 'Ihre Nachricht schreiben',
      'commentaire_envoye_succes': 'Nachricht erfolgreich gesendet',
      'commentaire_requis': 'Nachricht ist erforderlich',
      'nouveau_message': '{{count}} neue Nachricht',
      'nouveau_message_one': '{{count}} neue Nachricht',
      'nouveau_message_other': '{{count}} neue Nachrichten',
      'non_lu': '{{count}} ungelesen',
      'non_lu_one': '{{count}} ungelesen',
      'non_lu_other': '{{count}} ungelesen',
      'non_lu_many': '{{count}} ungelesen',
      'non_lu_plural': '{{count}} ungelesen',
      'voir_plus': 'mehr sehen',
      'messages': '{{count}} Nachricht',
      'messages_one': '{{count}} Nachricht',
      'messages_other': '{{count}} Nachrichten',
      'messages_singulier': '{{count}} Nachricht',
      'messages_pluriel': '{{count}} Nachrichten',
      'nouveau_message_singulier': '{{count}} neue Nachricht',
      'nouveau_message_pluriel': '{{count}} neue Nachrichten',
      'messages_commercial': 'Nachrichten Ihres Handelsvertreters'
    },
    'creer_liste': 'Neue Liste erstellen',
    'veuillez_entrer_nom_liste': 'Bitte geben Sie den Namen der neuen Liste ein',
    'veuillez_entrer_nouveau_nom_liste': 'Bitte geben Sie den neuen Namen der Liste ein',
    'nom_liste_placeholder': 'Name der neuen Liste',
    'liste_supprimee': 'Die Liste {{nom}} wurde gelöscht',
    'liste_renommee': 'Die Liste wurde umbenannt',
    'syntaxe_nom_liste': 'Nur Buchstaben, Zahlen und Leerzeichen sind erlaubt',
    'ajouter_a_une_liste': 'Zu einer Liste hinzufügen',
    'ajouter_a_la_liste': 'Zur Liste hinzufügen',
    'dans_la_liste': 'In der Liste',
    'dans_le_cadencier': 'Im Bestellrhythmus',
    'ajouter_au_cadencier': 'Zur Bestellvorlage hinzufügen',
    'aria_label_modifier': 'Namen der Liste ändern',
    'aria_label_enregistrer': 'Neuen Namen der Liste speichern',
    'aria_label_renommer': 'Liste umbenennen',
    'chargement_listes': 'Laden Ihrer Listen',
    'ajouter_article': 'Artikel hinzufügen',
    'veuillez-selectionner-ou-ajouter-larticle': 'Bitte wählen Sie aus, wo der Artikel hinzugefügt werden soll',
    'editer_nom_liste': 'Namen der Liste bearbeiten',
    'supprimer_liste_confirm': 'Möchten Sie diese Liste wirklich löschen?',
    'supprimer_liste_action': 'Liste löschen',
    'aucun_produit': 'Keine Produkte in dieser Liste',
    'selection_liste': 'Eine Liste auswählen',
    'selectionner_liste_pour_ajout': 'Wählen Sie eine Liste aus, um Produkte hinzuzufügen',
    'ajouter_produits': 'Produkte hinzufügen zu',
    'choisir_une_liste': 'Liste auswählen',
    'tooltip_ajouter_cadencier': 'Produkte zum Bestellrhythmus hinzufügen',
    'liste': 'Liste:',
    'produit_ajoute': 'Produkt zur Liste hinzugefügt',
    'aucune_liste': 'Keine Liste ausgewählt',
    'historique_achat': 'Kaufhistorie',
    'commande_x_fois': '{{count}} Mal bestellt',
    'produit_deja_dans_liste': 'Dieses Produkt ist bereits in Ihrer Liste',
    'selectionner_liste_tooltip': 'Eine Liste auswählen',
    'quantite_saisonniere_tooltip': 'Gelieferte Menge im ausgewählten Zeitraum',
    'trouver_alternative': 'Ersetzen',
    'mes_produits': 'Meine Produkte',
    'produits_par_saison_short': 'Nach Saison'
  },
  'operation_commerciale': {
    'voir_details': 'Entdecken',
    'retour': 'Zurück',
    'jusqu_au': 'Bis zum {{date}}',
    'article_hors_base': 'Artikel in der kommerziellen Aktion aber nicht in der FF-Datenbank ({{code_article}})'
  },
  'back_office': {
    'comment_ca_marche': 'Wie funktioniert das?',
    'unauthorized': 'Sie müssen mit Ihrer France Frais E-Mail-Adresse angemeldet sein.',
    'clients_ouverts': 'Status Offen',
    'chercher_client': 'Einen Kunden suchen',
    'societes': 'Gesellschaften',
    'metier': 'Branche',
    'representant': 'Vertrieb',
    'liste_operations_commerciales': 'Kommerzielle Aktionen',
    'liste_clients': 'Kunden',
    'nouvelle_operation_commerciale': 'Neue Aktion',
    'clients_avec_panier': 'Mit offenem Warenkorb',
    'adresse_depot': 'Abhollageradresse',
    'adresse_magasin': 'Geschäftsadresse',
    'liste_societes_commerciales': 'Liste der Vertriebsgesellschaften',
    'nom_etablissement': 'Name der Einrichtung',
    'etablissement': 'Niederlassung',
    'statut_tolede': 'Tolede-Status',
    'statut_tolede_ok': 'OK',
    'kpis': {
      'total_client': 'Kunden gesamt',
      'connexion': 'Anmeldung',
      'connectes': 'Angemeldet',
      'non_connectes': 'Nicht angemeldet',
      'commandes': 'Bestellungen',
      'ayant_commande': 'Bestellt',
      'nayant_pas_commande': 'Nicht bestellt',
      'toggle': {
        'trente_jours': 'Letzte 30 Tage',
        'depuis_debut': 'Seit Beginn',
      },
    },
    'livraisons': 'Lieferungen',
    'livraisons_sans_tournee': {
      'label': 'Keine Touren',
      'description': 'Wenn in Tolede keine Tour konfiguriert ist, haben die Kunden keinen Zugang zu France Frais Connect.',
    },
    'filiale': 'Tochtergesellschaft',
    'paniers': 'Warenkörbe',
    'paniers_origine': {
      'client': 'Kunde',
      'representant': 'Vertrieb',
      'processus_pdf': 'PDF-Import',
    },
    'paniers_origine_description': {
      'client': 'Vom Kunden geöffnete Warenkörbe',
      'representant': 'Vom Vertriebsmitarbeiter geöffnete Warenkörbe',
      'processus_pdf': 'Warenkörbe aus einem PDF-Bestellimport',
    },
    'panier_en_cours': 'Aktueller Warenkorb',
    'statut': 'Status',
    'nombre_commandes': 'Anzahl der Bestellungen',
    'statut_tooltip': 'Tolede-Geschäftsregel, um zu wissen, ob der Kunde in Tolede bestellen kann oder nicht (unabhängig von einem digitalen Aspekt)',
    'paniers_tooltip': 'Anzahl der offenen Warenkörbe des Kunden',
    'cgv': 'AGB',
    'pas_de_client': 'Kein Kunde',
    'prochaine_date_livraison': 'Nächste Lieferung am {{date_de_livraison}}',
    'cutoff_non_disponible': 'Cut-off nicht verfügbar',
    'rafraichir_clients': 'Kundenliste aktualisieren',
    'rafraichir_clients_tooltip': 'Aktualisiert die Kundenliste der Gesellschaft.',
    'invitation_envoyee_le': 'Einladung gesendet am {{date}}',
    'relance_envoyee_le': 'Mahnung gesendet am {{date}}',
    'email_ouvert_le_tooltip': 'Gesehen am {{date}}',
    'envoyer_relance_tooltip': 'Eine Mahnung an {{email}} senden',
    'envoyer_invitation_tooltip': 'Eine Einladung an {{email}} senden',
    'relance_message_placeholder': 'Ihre personalisierte Nachricht ... (optional)',
    'envoyer_email_relance': 'E-Mail senden',
    'relance_titre': 'Mahnung zur Bestellung auf France Frais Connect',
    'liste_emails_relance': 'An:',
    'historique_invitation': 'Verlauf der Einladung',
    'historique_relance': 'Verlauf der Mahnung',
    'historique_emails_titre': 'E-Mail-Verlauf',
    'email_ouvert_le': 'E-Mail geöffnet am {{date}}',
    'pas_historique_email': 'Die Tracking-Details sind nicht mehr verfügbar (nach 45 Tagen abgelaufen)',
    'actions_client': {
      'conversations': 'Gespräche',
      'etat_activation': 'Aktivierungsstatus',
    },
    'etat_activation': {
      'contacts': 'Kontakte',
      'connecte_le': 'Verbunden - {{date}}',
      'invitation_envoyee_le': 'Einladung gesendet - {{date}}',
    },
    'activation_statut': {
      'connecte': 'Verbunden',
      'non_connecte': 'Nicht verbunden',
      'sans_email': 'Ohne E-Mail',
      'a_commande': 'Hat bestellt',
      'na_pas_commande': 'Hat nicht bestellt',
    },
    'multicanal': 'Multi-Channel aktiv',
    'activation': 'FFConnect-Status',
    'activation_tooltip': {
      'titre':
        'FFConnect-Aktivitätsstatus der letzten 30 Tage ({{periode}})',
      'connecte': 'Verbunden: Anmeldung in FFConnect.',
      'a_commande': 'Hat bestellt: über FFConnect bestätigte Bestellung.',
      'na_pas_commande':
        'Hat nicht bestellt: verbunden, aber keine FFConnect-Bestellung.',
      'non_connecte': 'Nicht verbunden: keine Anmeldung im Zeitraum.',
      'sans_email':
        'Ohne E-Mail: keine E-Mail bekannt (Einladung unmöglich).',
      'note':
        'Direkt in Tolede erfasste Bestellungen zählen nicht.',
    },
    'jamais_validé': 'Nie bestätigt',
    'details_client': {
      'retour_clients': 'Zurück zur Kundenliste',
      'assistance_client': 'Kundenansicht',
      'prendre_une_commande': 'Bestellung aufnehmen',
      'voir_les_statistiques': 'Statistiken anzeigen',
      'informations_livraison': 'Lieferinformationen',
      'informations_societe': 'Unternehmensinformationen',
      'jours_de_livraison': 'Liefertage',
      'semaine_paire': 'Gerade Woche',
      'semaine_impaire': 'Ungerade Woche',
      'client_actionnaire': 'Aktionärskunde',
      'tournees': 'Touren',
      'parametrages': 'Einstellungen',
      'catalogue_client': 'Kundenkatalog',
      'rafraichir_catalogue': 'Katalog aktualisieren',
      'cadencier_tendances': 'Bestellliste',
      'tendance': {
        'en_hausse_one': 'Steigend',
        'en_hausse_other': 'Steigend',
        'gagne_one': 'Gewonnen',
        'gagne_other': 'Gewonnen',
        'stable_one': 'Stabil',
        'stable_other': 'Stabil',
        'en_baisse_one': 'Fallend',
        'en_baisse_other': 'Fallend',
        'perdu_one': 'Verloren',
        'perdu_other': 'Verloren',
        'a_gagner_one': 'Nicht bestellt',
        'a_gagner_other': 'Nicht bestellt',
      },
      'paniers_ouverts': 'Offene Warenkörbe',
      'rempli_par': {
        'client': 'Kunde',
        'representant': 'Vertreter',
        'processus_pdf': 'PDF',
      },
      'mis_a_jour_le': 'Aktualisiert am {{date}}',
      'reprendre_le_panier': 'Warenkorb fortsetzen',
      'consulter_le_panier': 'Warenkorb ansehen',
      'dernieres_commandes': '{{count}} letzte Bestellungen',
      'dernieres_commandes_one': '{{count}} letzte Bestellung',
      'dernieres_commandes_other': '{{count}} letzte Bestellungen',
      'dernieres_commandes_titre': 'Letzte Bestellungen',
      'client_aucune_commande': 'Der Kunde hat keine Bestellungen',
      'toutes_les_commandes': 'Alle Bestellungen',
      'ub_essentielles': 'Essentielle UBs',
      'ub_statut': {
        'gagne_one': 'Aktiv',
        'gagne_other': 'Aktiv',
        'en_baisse_one': 'Fallend',
        'en_baisse_other': 'Fallend',
        'perdu_one': 'Verloren',
        'perdu_other': 'Verloren',
        'a_gagner_one': 'Zu gewinnen',
        'a_gagner_other': 'Zu gewinnen',
      },
      'informations_client': 'Kundeninformationen',
      'contacts': 'Kontakte',
      'code_client': 'Kundenkonto',
      'paniers': 'Warenkörbe',
      'panier_en_cours': 'Aktueller Warenkorb',
      'panier_commercial': 'Vertriebswarenkorb',
      'pas_de_panier_en_cours': 'Kein aktueller Warenkorb',
      'paniers_historique': 'Warenkörbe',
      'paniers_historique_aria': 'Warenkorb-Verlauf anzeigen',
      'paniers_historique_vide': 'Kein Warenkorb-Ereignis',
      'panier_event_id': 'Warenkorb-ID',
      'panier_event_statut': 'Warenkorb-Status',
      'panier_event_date': 'Ereignisdatum',
      'panier_event_message': 'Nachricht',
      'panier_event_payload': 'Payload',
      'panier_event_valide': 'Validiert',
      'panier_event_echec': 'Fehlgeschlagen',
      'information_a_renseigner': 'Die Informationen müssen in Tolede eingegeben werden.',
      'rafraichissement': 'Wird aktualisiert ...',
      'rafraichir_contacts': 'Kontakte aktualisieren',
      'rafraichir_contacts_tooltip': 'Aktualisiert die Kontaktliste des Kunden nach einer Änderung oder Ergänzung in Tolede.',
      'rafraichir_catalogue_tooltip': 'Aktualisiert die in Tolede vorgenommenen Änderungen an Artikeln und Tarifen des Kunden.',
      'affiche_dlc_modifie': 'Die Anzeige des MHD wurde geändert.',
      'affichage_dlc': 'MHD anzeigen',
      'affiche_produit_marche_modifie': 'Die Anzeige des Marktprodukts wurde geändert.',
      'affichage_produit_marche': 'Marktprodukte anzeigen',
      'affiche_prix_ttc_modifie': 'Die Anzeige der Bruttopreise wurde geändert.',
      'affichage_prix_ttc': 'Bruttopreise anzeigen',
      'denomination_sociale': 'Firma',
      'pas_de_contact': 'Kein Kontakt angegeben',
      'voir_tous_les_contacts': 'Alle Kontakte anzeigen',
      'adresse_precedente': 'Vorherige Adresse',
      'adresse_suivante': 'Nächste Adresse',
      'cgv_tooltip': 'Datum der Annahme der AGB',
      'profils_ub': 'UB Essentielles Profile',
      'profils_ub_description': 'Mit dem Kunden verknüpfte UB Essentielles Profile.',
      'gerer_profils_ub': 'UB-Profile verwalten',
      'profils_associes': '{{count}} Profil verknüpft',
      'profils_associes_one': '{{count}} Profil verknüpft',
      'profils_associes_other': '{{count}} Profile verknüpft',
      'aucun_profil_associe': 'Kein Profil verknüpft',
      'aucun_profil_associe_description': 'Derzeit ist kein UB Essentielles-Profil mit diesem Kunden verknüpft. Klicken Sie auf das Bearbeitungssymbol, um eines zu verknüpfen.',
      'chargement_profils': 'Profile werden geladen...',
      'aucun_profil_disponible': 'Kein UB-Profil verfügbar',
      'nombre_items': '{{count}} Artikel',
      'nombre_items_one': '{{count}} Artikel',
      'nombre_items_other': '{{count}} Artikel',
      'message': 'Nachricht',
      'date': 'Datum des Ereignisses',
      'telecharger': 'Payload',
      'identifiant_panier': 'Warenkorb-ID',
      'statut_panier': 'Status des Warenkorbs',
      'quinze_derniers_jours': 'In den letzten 15 Tagen.',
      'validé': 'Bestätigt',
      'erreur_inconnue': 'Unbekannter Fehler',
      'nombre_produits': 'Anzahl der Produkte',
      'no_events': 'Keine Bestätigung oder Fehler bei der Warenkorbvalidierung in den letzten 30 Tagen.',
      'contacts_tooltip': 'Liste der im Web markierten Kontakte in Tolede, die auf FFConnect zugreifen können'
    },
    'prise_de_commande': {
      'liste_clients': {
        'title': 'Bestellaufnahme',
        'reprendre_commande': 'Fortsetzen',
        'paniers': 'Warenkörbe des Vertriebsmitarbeiters',
        'paniers_tooltip': 'Liste der laufenden Warenkörbe, die von einem Vertriebsmitarbeiter erstellt wurden. Die laufenden Warenkörbe des Kunden sind in der Kundenkartei sichtbar.',
        'nouveau_panier': 'Neuer Warenkorb',
        'livraison_date': 'Lieferung am {{date}}',
        'aucun_panier': 'Kein Warenkorb',
        'article': '{{count}} Artikel',
        'article_one': '{{count}} Artikel',
        'article_other': '{{count}} Artikel',
        'article_many': '{{count}} Artikel',
        'article_plural': '{{count}} Artikel',
        'total_ht': 'Gesamt Netto:',
        'derniere_maj': 'Letzte Aktualisierung am {{date}}',
        'derniere_commande': 'Letzte Bestellung',
        'aucun_client': 'Kein Kunde gefunden',
        'tooltip_aucune_livraison': 'Für diesen Kunden ist kein Lieferdatum verfügbar.',
        'commande_commerciale': 'Kommerzielle Bestellung',
        'aucune_date_disponible': 'Für diesen Kunden ist kein Lieferdatum verfügbar.',
        'actions': 'Aktionen',
        'actions_tooltip': 'Erstellen Sie einen neuen Warenkorb für Ihren Kunden.',
        'panier_commercial_en_cours_tooltip': 'Laufender kommerzieller Warenkorb',
        'commande_commercial_existante_tooltip': 'Bestehende kommerzielle Bestellung für diesen Liefertag',
        'profil': '{{count}} Profil',
        'profil_one': '{{count}} Profil',
        'profil_other': '{{count}} Profile',
        'profil_many': '{{count}} Profile',
        'profil_plural': '{{count}} Profile'
      },
      'panier': {
        'promotions': 'Angebote',
        'catalogue': 'Katalog',
        'cadencier': 'Bestellvorlage',
        'devis_personnalises': 'Personalisierte Angebote',
        'ub': 'Die Essentials',
        'tout': 'Alle ({{count}})',
        'panier_vide': 'Der Warenkorb ist leer!',
        'ajouter_articles_depuis': 'Artikel hinzufügen aus:',
        'date_de_livraison': 'Lieferdatum',
        'commander_autre_date': 'Für ein anderes Datum bestellen',
        'adresse_de_livraison': 'Lieferadresse',
        'changer_adresse': 'Lieferadresse ändern',
        'reference_commande': 'Bestellreferenz',
        'chargement_tooltip': 'Das Laden der Daten kann einige Minuten dauern.',
        'chargement_donnees': 'Laden der Daten Ihres Kunden ...',
        'voir_fiche_client': 'Kundenblatt anzeigen',
        'differer_aussi_panier': 'Produkte des aktuellen Warenkorbs ebenfalls verschieben',
        'erreur_chargement': 'Fehler beim Laden der Kundendaten.',
        'stock': 'Lager: {{count}} {{unite}}',
        'dlc_stock_sans_donnees': 'Keine MHD- und Lagerdaten für diesen Artikel verfügbar.',
        'prix_total': 'Gesamtpreis',
        'prix_unite': 'Stückpreis',
        'prix_saisi': 'Eingegebener Preis',
        'reinitialiser_prix': 'Preis zurücksetzen',
        'prix_post_promo': 'Preis nach Aktion: {{prix}} €',
        'prix_bloque': 'In Ausnahmeregelung integrieren',
        'prix_bloque_label': 'In Ausnr. zu integr.',
        'marges_totales': 'MW <bold>{{vm}}</bold> / MS <bold>{{tm}}</bold> / MK <bold>{{mk}}</bold>',
        'prix_modifie_succes': 'Preis erfolgreich geändert',
        'ajout_rapide': 'Schnellhinzufügen',
        'recherche_rapide': 'Artikel suchen...',
        'chargement_articles': 'Artikel werden geladen',
        'soit': 'Entspricht',
        'profils': 'Profile',
        'pas_de_produits': 'Keine Produkte',
        'ub_status': {
          'a-gagner': 'Zu gewinnen',
          'en-baisse': 'Rückläufig',
          'perdu': 'Verloren',
          'gagne': 'Gewonnen',
          'ras': 'Stabil'
        },
        'ub_status_nombre': {
          'a-gagner': '{{count}} zu gewinnen',
          'en-baisse': '{{count}} rückläufig',
          'perdu': '{{count}} verloren',
          'gagne': '{{count}} gewonnen',
          'ras': '{{count}} stabil',
          'perdu_one': '{{count}} verloren',
          'perdu_many': '{{count}} verloren',
          'perdu_other': '{{count}} verloren',
          'perdu_plural': '{{count}} verloren',
          'gagne_one': '{{count}} gewonnen',
          'gagne_many': '{{count}} gewonnen',
          'gagne_other': '{{count}} gewonnen',
          'gagne_plural': '{{count}} gewonnen',
          'ras_one': '{{count}} stabil',
          'ras_many': '{{count}} stabil',
          'ras_other': '{{count}} stabil',
          'ras_plural': '{{count}} stabil'
        },
        'ub_status_nombre_filtres': {
          'a-gagner': 'Zu gewinnen ({{count}})',
          'en-baisse': 'Rückläufig ({{count}})',
          'perdu': 'Verloren ({{count}})',
          'gagne': 'Gewonnen ({{count}})',
          'ras': 'Stabil ({{count}})'
        },
        'ub_tooltip': 'Die Profile können in der Kundenkartei geändert werden.',
        'ub_section_regles': '<strong>Gewonnen</strong>: mindestens ein UB-Artikel wurde in den letzten 30 Tagen einmal bestellt.<br/><strong>Verloren</strong>: in den letzten 30 Tagen wurde kein Artikel in der UB bestellt, verglichen mit den vorherigen 30 Tagen.<br/><strong>Rückläufig</strong>: 30% Rückgang des Gewichts der UB-Artikel in den letzten 30 Tagen im Vergleich zu den vorherigen 30 Tagen.<br/><strong>Zu gewinnen</strong>: in den letzten 60 Tagen wurde kein UB-Artikel bestellt.',
        'ub_section_tooltip': 'Unter-Unterfamilie der Nomenklatur:<br/> {{nom_famille}}',
        'confirmation_degradation_prix_metier': {
          'titre': 'Bestätigung der Geschäftspreis-Degradierung',
          'question': 'Sind Sie sicher, dass Sie den Geschäftspreis herabsetzen möchten?',
          'info': '<bold>Der Geschäftspreis ist der günstigste Preis</bold>, es ist der Preis, der je nach Beruf des Kunden angewendet wird.',
          'annuler': 'Abbrechen',
          'degrader': 'Preis herabsetzen'
        },
        'marges': 'Margen',
        'matching': 'Matching',
        'matching_titre': 'Matching-Bericht',
        'matching_non_disponible': 'Matching-Bericht nicht verfügbar',
        'ajouter_au_panier': 'Produkt hinzufügen'
      },
      'confirmation': {
        'commande_confirmee': 'Bestellung bestätigt!',
        'livraison_du': 'Lieferung am {{date}}',
        'message_confirmation': 'Sie können die Details der Bestellung jederzeit im Bereich "Meine Bestellungen" Ihres Kunden einsehen.',
        'terminer': 'Beenden'
      },
      'drawer': {
        'ajouter_produits': 'Produkte hinzufügen',
        'choisir_categorie': 'Eine Kategorie wählen',
        'aucun_produit_disponible': 'Kein Produkt verfügbar',
        'ajouter': 'Hinzufügen',
        'details_produit': 'Produktdetails',
        'aucun_resultat_recherche': 'Keine Ergebnisse für die Suche',
        'fin_liste': 'Ende der Liste'
      },
      'aucune_societe_commerciale': 'Keine Vertriebsgesellschaft'
    },
    'devis_personnalises': {
      'titre': 'Personalisierte Angebote',
      'devis': 'Angebot',
      'actions': 'Aktionen',
      'pas_de_devis_en_cours': 'Keine laufenden Angebote',
      'nouveau_devis': 'Neues Angebot',
      'modifie_le': 'Geändert am {{date}}',
      'aucun_client': 'Kein Kunde gefunden',
      'numero_devis': 'Angebot {{numero}}',
      'devis_visible': 'Angebot sichtbar',
      'devis_masque': 'Angebot ausgeblendet',
      'cree_le': 'Erstellt am {{date}}',
      'envoyer_message_client': 'Nachricht an den Kunden senden',
      'repondre': 'Antworten',
      'message_envoye_succes': 'Nachricht erfolgreich gesendet',
      'message_requis': 'Nachricht ist erforderlich',
      'contact_destinataire_requis': 'Bitte wählen Sie einen Empfänger-Kontakt aus',
      'contact_destinataire': 'Empfänger-Kontakt',
      'choisir_contact': 'Kontakt auswählen...',
      'nouveau_message_client': 'Sie haben {{count}} neue Nachricht von Ihrem Kunden erhalten',
      'nouveau_message_client_one': 'Sie haben {{count}} neue Nachricht von Ihrem Kunden erhalten',
      'nouveau_message_client_other': 'Sie haben {{count}} neue Nachrichten von Ihrem Kunden erhalten',
      'voir': 'Ansehen',
      'client': 'Kunde',
      'message': 'Nachricht',
      'placeholder_message': 'Geben Sie hier Ihre Nachricht ein...',
      'caracteres': 'Zeichen',
      'tooltip_message_email': '- Eine E-Mail wird gesendet:<br/>Hallo,<br/>[Inhalt Ihrer Nachricht]<br/>Angebot ansehen Schaltfläche<br/>Mit freundlichen Grüßen,<br/>Ihre Unterschrift<br/><br/>- [Inhalt Ihrer Nachricht] wird im Angebot Ihres Kunden auf der FFConnect-Seite angezeigt',
      'historique': 'Verlauf',
      'historique_titre': 'Aktivität',
      'historique_tooltip': 'Aktivität anzeigen',
      'historique_onglet_tout': 'Alle',
      'historique_onglet_visibilite': 'Sichtbarkeit',
      'historique_onglet_articles': 'Artikel',
      'historique_onglet_messages': 'Nachrichten',
      'historique_onglet_derogations': 'Ausnahmen',
      'historique_tooltip_derogations': 'Ausnahmeantrag oder Validierung',
      'historique_aucun_evenement': 'Keine Ereignisse in dieser Kategorie',
      'nouveaux_messages': 'neue Nachricht',
      'nouveaux_messages_one': 'neue Nachricht',
      'nouveaux_messages_other': 'neue Nachrichten',
      'historique_vierge': 'Bisher kein Verlauf',
      'derniere_consultation': 'Zuletzt angesehen von {{contact}}',
      'derniere_consultation_date': '{{date}}',
      'ajouter_produits': 'Mehr Produkte',
      'chargement_catalogue': 'Kundenkatalog wird geladen...',
      'demander_derogations': 'Ausnahme beantragen',
      'injecter_derogations': 'Ausnahmen validieren',
      'info_demande_derogation': 'Sie sind dabei, die Genehmigung für {{nombreDerogations}} Ausnahme(n) für das Angebot {{devisId}} zu beantragen.',
      'nombre_derogations_a_injecter': '{{nombre}} Ausnahme(n) zu injizieren',
      'date_fin_validite': 'Ablaufdatum',
      'date_fin_validite_placeholder': 'Datum auswählen',
      'marges_ligne': 'MW <bold>{{vm}}</bold> / MP <bold>{{tm}}</bold> / M€/kg <bold>{{mk}}</bold>',
      'tooltip_marges': '<strong>MW (Margenwert):</strong> Differenz zwischen Katalogpreis und Margenbasis (Katalogpreis - Margenbasis).<br/><strong>MP (Margenprozentsatz):</strong> Margenprozentsatz ((MW / Margenbasis) × 100).<br/><strong>M€/kg (Marge €/kg):</strong> Marge pro Kilogramm ((Katalogpreis - Margenbasis) / kg-Koeffizient).',
      'date_fin_validite_aide': 'Die Ausnahmen sind bis zu diesem Datum gültig',
      'injection_non_disponible': 'Injection nicht verfügbar',
      'injection_non_disponible_raisons': 'Injection ist nicht möglich: Entweder fehlen die erforderlichen Berechtigungen, es gibt keine Ausnahmen zu injizieren oder das Angebot ist archiviert.',
      'manager_destinataire': 'Empfänger-Manager',
      'choisir_manager': 'Manager auswählen...',
      'saisir_email_manager': 'Manager-E-Mail eingeben',
      'message_explicatif': 'Erklärende Nachricht',
      'message_placeholder': 'Bitte erklären Sie den Grund für diese Ausnahmeanfrage...',
      'message_demande_derogation_defaut': 'Hallo,\n\nIch bitte um Ihre Genehmigung für {{nombreDerogations}} Ausnahme(n).\n\nMit freundlichen Grüßen',
      'envoyer_demande': 'Anfrage senden',
      'envoi_en_cours': 'Wird gesendet...',
      'demande_derogation_envoyee': 'Ausnahmeanfrage erfolgreich gesendet',
      'derogations_injectees_succes': 'Ausnahmegenehmigungen erfolgreich in Tolède eingefügt',
      'prix_en_cours_actualisation': 'Preise werden aktualisiert',
      'refresh_catalogue': {
        'titre': 'Kundenkatalog-Aktualisierung',
        'message_principal': 'Wir aktualisieren den Katalog Ihres Kunden, damit die Ausnahmepreise berücksichtigt werden. Dies kann einige Minuten dauern.',
        'info_fermeture': 'Wenn Sie dieses Modal schließen, wird der Katalog weiterhin aktualisiert und die Änderungen sind sichtbar, sobald die Aktualisierung abgeschlossen ist.',
        'succes_message': 'Der Katalog Ihres Kunden wurde erfolgreich aktualisiert. Die neuen Preise mit Ausnahmegenehmigungen sind jetzt verfügbar.'
      },
      'ajouter_au_devis': 'Zum Angebot hinzufügen',
      'ajout_rapide': 'Schnellhinzufügen',
      'recherche_rapide': 'Artikel suchen...',
      'article_ajoute_au_devis': 'Der Artikel wurde erfolgreich zum Angebot hinzugefügt',
      'liste_produits': 'Produktliste',
      'ajouter_une_note': '+ Notiz hinzufügen',
      'prix': '{{prix}} €HT/',
      'prix_dero_souhaite': 'Gewünschter Sonderpreis',
      'prix_dero_valide': 'Bestätigter Sonderpreis',
      'alerte_prix_plancher_depasse': '{{libelle}} ({{code_article}}): Der eingegebene Preis ({{prix_saisi}} €netto) liegt unter dem Mindestpreis ({{prix_plancher}} €netto)',
      'tarif_promotion': 'Aktion',
      'tarif_marche': 'Markt',
      'tarif_derogation': 'Sonderpreis',
      'tarif_general': 'Allgemeiner Tarif',
      'tarif_metier': 'Geschäftspreis',
      'tarif_degagement': 'Abverkauf',
      'tarif_prix_en_cours': 'Aktueller Preis',
      'tarif_non_precise': 'Nicht angegeben',
      'tarif_non_precise_tooltip':
        'Tolede hat die Kategorie dieses Preises nicht übermittelt (Allgemeiner Tarif, Geschäftspreis, Sonderpreis…)',
      'aucun_tarif_disponible': 'Kein Tarif verfügbar',
      'panel_prix_titre': 'Preis',
      'panel_prix_categorie': 'Kategorie',
      'panel_prix_prix': 'Preis',
      'vider_le_devis': 'Angebot leeren',
      'vider_devis_confirmation': 'Sind Sie sicher, dass Sie dieses Angebot leeren möchten? Diese Aktion entfernt alle Produkte aus dem Angebot.',
      'derniere_maj': 'Letzte Aktualisierung am {{date}}',
      'devis_publie_succes': 'Das Angebot ist jetzt für den Kunden sichtbar',
      'devis_depublie_succes': 'Das Angebot wurde für den Kunden ausgeblendet',
      'devis_vide_succes': 'Das Angebot wurde erfolgreich geleert',
      'archiver': 'Archivieren',
      'tooltip_archiver': 'Durch Archivierung wird dieses Angebot nicht mehr sichtbar oder zugänglich sein.',
      'devis_archive_succes': 'Das Angebot wurde erfolgreich archiviert',
      'aucun_produit_ancien_devis': 'Keine Produkte in alten Angeboten gefunden',
      'pas_encore_dans_tolede': 'Noch nicht in Tolède',
      'pas_encore_devis_tolede': 'Noch kein Tolède-Angebot',
      'tooltip_pas_encore_devis': 'Noch kein Tolède-Angebot: Das Angebot wird in Tolède eingefügt, wenn Sie klicken, um eine Validierung der gewünschten Ausnahmen anzufordern oder wenn Sie die Ausnahmen validieren oder wenn Sie das Angebot sichtbar machen.',
      'tooltip_numero_devis': 'Tolède-Angebotsnummer',
      'tooltip_numero_devis_avec_tolede': 'Tolède-Angebotsnummer: {{numero}}',
      'devis_sans_nom': 'Angebot vom {{date}}',
      'nom_du_devis': 'Angebotsname',
      'nom_modifie_succes': 'Der Angebotsname wurde erfolgreich geändert',
      'caracteres_restants': '{{count}} Zeichen übrig',
      'caracteres_restants_one': '{{count}} Zeichen übrig',
      'caracteres_restants_other': '{{count}} Zeichen übrig',
      'tooltip_valider_derogations': 'Durch Klicken werden die gewünschten Ausnahmen in Tolède eingespritzt.',
      'tooltip_demander_derogations': 'Durch Klicken können Sie eine Validierung der gewünschten Ausnahmen von Ihrem Vorgesetzten anfordern. Das Angebot wird auch in Tolède eingespritzt.',
      'tooltip_injecter_tolede': 'Das Angebot in Tolede einspeisen (die Artikel werden automatisch zum Zeitplan des Kunden hinzugefügt).',
      'injecter_dans_tolede': 'In Tolede einspeisen',
      'devis_injecte_tolede_succes': 'Das Angebot wurde erfolgreich in Tolede eingespritzt',
      'tooltip_devis_visibilite': '<strong>Angebot sichtbar aktiviert:</strong> Ihr Angebot wird für den Kunden von seinem France Frais Connect-Konto aus sichtbar sein und die Artikel werden in seinem Planer vorhanden sein.<br/>Nur ein Angebot kann im FFConnect-Bereich des Kunden sichtbar sein. Wenn Sie ein anderes sichtbares Angebot haben, wird es ausgeblendet, wenn Sie dieses Angebot sichtbar machen.<br/><strong>Angebot sichtbar deaktiviert:</strong> Ihr Angebot ist für den Kunden von seinem France Frais Connect-Konto aus nicht sichtbar.',
      'onglet_devis_personnalises_tooltip': 'Artikel aus alten personalisierten Angeboten',
      'tooltip_derogation_non_autorisée': 'Sonderpreise sind für diesen Artikel nicht autorisiert',
      'erreur_modification_prix_promotion': 'Preisänderungen sind bei Aktionen nicht erlaubt',
      'erreur_modification_prix_marche': 'Preisänderungen sind bei Marktpreisen nicht erlaubt',
      'supprimer_prix_derogation': 'Eingegebenen Sonderpreis entfernen',
      'derogation_non_ajustable': 'Preis kann nicht geändert werden: nicht anpassbare Sonderpreisregelung für diesen Artikel',
      'dero_souhaitee_validee': 'Gewünschte Sonderpreisregelung validiert',
      'dero_souhaitee_pas_encore_validee': 'Gewünschte Sonderpreisregelung noch nicht validiert',
      'prix_promo_actuel': 'Derzeit gültiger Aktionspreis: {{prix}} €',
      'historique_evenements': {
        'devis_cree': 'Angebot erstellt',
        'produit_avec_libelle_ajoute': 'Produkt "{{codeArticle}}" {{libelle}} hinzugefügt',
        'produit_ajoute': 'Produkt "{{codeArticle}}" hinzugefügt',
        'produit_ajoute_generique': 'Produkt hinzugefügt',
        'produit_avec_libelle_supprime': 'Produkt "{{codeArticle}}" {{libelle}} entfernt',
        'produit_supprime': 'Produkt "{{codeArticle}}" entfernt',
        'produit_supprime_generique': 'Produkt entfernt',
        'devis_vide': 'Angebot geleert',
        'note_modifiee_avec_libelle': 'Notiz geändert für "{{codeArticle}}" {{libelle}}',
        'note_modifiee': 'Notiz geändert für "{{codeArticle}}"',
        'note_modifiee_generique': 'Notiz geändert',
        'prix_modifie_complet': 'Preis geändert für "{{codeArticle}}" {{libelle}}: {{prixPrecedent}}€ → {{nouveauPrix}}€',
        'prix_modifie': 'Preis geändert für "{{codeArticle}}"',
        'prix_modifie_generique': 'Preis geändert',
        'devis_publie': 'Angebot sichtbar',
        'devis_publie_par': 'Angebot sichtbar gemacht von {{auteur_nom}}',
        'devis_depublie': 'Angebot ausgeblendet',
        'devis_depublie_par': 'Angebot ausgeblendet von {{auteur_nom}}',
        'devis_archive': 'Angebot archiviert',
        'message_commercial_envoye': 'Nachricht gesendet von {{expediteur_nom}}',
        'message_commercial_avec_contenu': '{{expediteur_nom}} an {{destinataire_email}}',
        'message_commercial_envoye_generique': 'Nachricht vom Handelsvertreter gesendet',
        'commentaire_client_envoye': 'Kommentar gesendet von {{expediteur_nom}}',
        'commentaire_client_envoye_generique': 'Kommentar vom Kunden gesendet',
        'message_client_recu': '{{expediteur_nom}}',
        'message_client_recu_generique': 'Nachricht vom Kunden erhalten',
        'derogations_demandees_complet_one': '{{count}} Ausnahmeanfrage gesendet von {{expediteur_nom}} an {{email_manager}}',
        'derogations_demandees_complet_other': '{{count}} Ausnahmeanfragen gesendet von {{expediteur_nom}} an {{email_manager}}',
        'derogations_demandees_par_one': '{{count}} Ausnahmeanfrage gesendet von {{expediteur_nom}}',
        'derogations_demandees_par_other': '{{count}} Ausnahmeanfragen gesendet von {{expediteur_nom}}',
        'derogations_demandees_generique_one': '{{count}} Ausnahmeanfrage gesendet',
        'derogations_demandees_generique_other': '{{count}} Ausnahmeanfragen gesendet',
        'derogations_injectees_par_one': '{{count}} Ausnahme injiziert von {{injecte_par_nom}}',
        'derogations_injectees_par_other': '{{count}} Ausnahmen injiziert von {{injecte_par_nom}}',
        'derogations_injectees_generique_one': '{{count}} Ausnahme injiziert',
        'derogations_injectees_generique_other': '{{count}} Ausnahmen injiziert',
        'evenement_inconnu': 'Unbekanntes Ereignis',
        'devis_consulte_par': 'Angebot eingesehen von {{contact}}',
        'devis_consulte': 'Angebot eingesehen'
      },
      'mode_synako': 'Synako-Modus',
      'mode_synako_demande': 'Ausnahmegenehmigungsanfragen-Modus',
      'mode_synako_injection': 'Ausnahmegenehmigungsinjektions-Modus',
      'tooltip_message_email_demande_derogation': '- Eine E-Mail wird gesendet:<br/>Hallo,<br/>[Inhalt Ihrer Nachricht]<br/>Schaltfläche Angebot einsehen<br/>Mit freundlichen Grüßen,<br/>Ihre Unterschrift<br/>',
      'evenement_fallback': 'Ereignis: {{type}}',
      'evenement_non_defini': 'Nicht definiert',
      'message_demande_derogation_defaut_one': 'Können Sie meinen Antrag auf {{count}} Ausnahmegenehmigung validieren?',
      'message_demande_derogation_defaut_many': 'Können Sie meine Anträge auf {{count}} Ausnahmegenehmigungen validieren?',
      'message_demande_derogation_defaut_other': 'Können Sie meine Anträge auf {{count}} Ausnahmegenehmigungen validieren?',
      'message_demande_derogation_defaut_plural': 'Können Sie meine Anträge auf {{count}} Ausnahmegenehmigungen validieren?',
      'ajouter_une_note_placeholder': 'Eine Notiz hinzufügen ...',
      'note_commerciale': 'Notiz des Handelsvertreters',
      'pre_remplir_plus_produit': 'Mit dem + des Produkts vorausfüllen'
    },
    'menu': {
      'clients': 'Kunden',
      'commandes': 'Bestellungen',
      'catalogue_grand_compte': 'France Frais Katalog',
      'operations_commerciales': 'Kommerzielle Aktionen',
      'commandes_pdf': 'PDF-Bestellungen',
      'changelog': 'Änderungsprotokoll',
      'roadmap': 'Roadmap',
      'devis': 'Angebote',
      'conversations': 'Gespräche',
      'maintenance': 'Wartung',
      'administration_fonctionnalites': 'Funktionszugänge',
      'retour_accueil': 'Zurück zur Firmenliste'
    },
    'administration_fonctionnalites': {
      'delai_cache': 'Änderungen werden innerhalb einer Minute wirksam.',
      'acces_refuse': 'Sie haben keinen Zugriff auf diese Seite.',
      'succes': 'Änderung gespeichert',
      'clients_actionnaires': {
        'titre': 'Aktionärskunden',
        'description':
          'Parametrisiert für gerade oder ungerade Wochen. Laden Sie die Excel-Datei hoch (Spalten Code Tolède und SEMAINE LIVRAISON), um die Liste vollständig zu ersetzen.',
        'format_excel': 'Erwartetes Excel-Format',
        'compteur_one': '{{count}} konfigurierter Kunde',
        'compteur_other': '{{count}} konfigurierte Kunden',
        'compteur_plural': '{{count}} konfigurierte Kunden',
        'importer': 'Excel-Datei importieren',
        'succes':
          'Import abgeschlossen: {{count}} Zeile(n) angewendet, {{inconnus}} unbekannte(r) Code(s), {{invalides}} abgelehnte Zeile(n).',
      },
      'ajouter': 'Hinzufügen',
      'aucun_email': 'Keine E-Mail',
      'aucun_resultat': 'Kein Ergebnis für „{{recherche}}“',
      'recherche_email_placeholder': 'E-Mail suchen…',
      'compteur_emails_one': '{{count}} E-Mail',
      'compteur_emails_other': '{{count}} E-Mails',
      'compteur_emails_plural': '{{count}} E-Mails',
      'supprimer_email': 'E-Mail entfernen',
      'email_placeholder': 'email@beispiel.de',
      'actif': 'Aktiviert',
      'inactif': 'Deaktiviert',
      'toutes_les_societes': 'Alle Gesellschaften',
      'aucune_societe': 'Keine Gesellschaft',
      'ajouter_societes': 'Gesellschaften hinzufügen',
      'supprimer_societe': 'Gesellschaft entfernen',
      'ou': 'ODER',
      'actif_pour_tous': 'Für alle aktiviert',
      'societes_autorisees': 'Zugelassene Gesellschaften',
      'utilisateurs_autorises': 'Zugelassene Benutzer',
      'utilisateurs_operations_nationales': 'Benutzer nationaler Aktionen',
      'administrer_utilisateurs': 'Benutzer der Funktion verwalten',
      'phrase_utilisateurs': 'Diese Liste ist nur änderbar, wenn „Für alle aktiviert“ aus ist.',
      'zones': {
        'deploiement': 'Einführung',
        'administrateurs': 'Administratoren',
        'delegues': 'Wer die Zugänge verwalten darf',
      },
      'categories': {
        'operations_commerciales': 'Verkaufsaktionen',
        'commandes_pdf': 'PDF-Bestellungen',
        'prise_de_commande': 'Bestellaufnahme',
        'mode_commercial': 'Verkaufsmodus',
        'devis_tarifaires': 'Individuelle Angebote',
        'ub_essentielles': 'Wesentliche Bedarfseinheiten',
        'conversations': 'Gespräche',
        'egalim': 'Egalim',
        'roadmap': 'Roadmap',
        'maintenance': 'Wartung',
        'sandbox': 'SBX-Zugang',
        'tolede': 'Tolède',
      },
      'cles': {
        'operation_commerciale_test_users': 'Test-E-Mails',
        'operation_commerciale_nationale_authorized_users': 'Administratoren nationaler Aktionen',
        'operation_commerciale_enable': 'Für alle aktiviert',
        'societe_commerciale_operation_commerciale_autorisee': 'Zugelassene Gesellschaften',
        'pdf_order_import_test_users': 'Test-E-Mails',
        'pdf_order_import_enabled': 'Für alle aktiviert',
        'prise_de_commande_test_users': 'Test-E-Mails',
        'prise_de_commande_enable': 'Für alle aktiviert',
        'societe_commerciale_prise_de_commande_autorisee': 'Zugelassene Gesellschaften',
        'mode_commercial_test_users': 'Test-E-Mails',
        'mode_commercial_enable': 'Für alle aktiviert',
        'societe_commerciale_mode_commercial_autorisee': 'Zugelassene Gesellschaften',
        'devis_tarifaires_test_users': 'Test-E-Mails',
        'devis_tarifaires_enable': 'Für alle aktiviert',
        'societe_commerciale_devis_tarifaires_autorisee': 'Zugelassene Gesellschaften',
        'ub_essentielles_test_users': 'Test-E-Mails',
        'ub_essentielles_enable': 'Für alle aktiviert',
        'societe_commerciale_ub_essentielles_autorisee': 'Zugelassene Gesellschaften',
        'conversations_test_users': 'Test-E-Mails',
        'conversations_enable': 'Für alle aktiviert',
        'conversations_toutes_enable': 'Zugriff auf alle Gespräche',
        'societe_commerciale_conversations_autorisee': 'Zugelassene Gesellschaften',
        'egalim_test_users': 'Test-E-Mails',
        'egalim_enable': 'Für alle aktiviert',
        'societe_commerciale_egalim_autorisee': 'Zugelassene Gesellschaften',
        'roadmap_authorized_users': 'Zugelassene E-Mails',
        'maintenance_authorized_users': 'Zugelassene E-Mails',
        'sbx_authorized_users': 'Zugelassene E-Mails',
        'tolede_authorized_users': 'E-Mails erlaubt im Safelive',
        'tolede_unauthorized_users': 'E-Mails ausgeschlossen im Normalmodus',
        'delegues': 'Wer die Zugänge verwalten darf',
      },
    },
    'conversations': {
      'titre': 'Gespräche',
      'nouvelle_conversation': 'Neues Gespräch',
      'initier_conversation': 'Gespräch erstellen',
      'commencer_conversation': 'Gespräch beginnen',
      'client': 'Kunde',
      'rechercher_client_placeholder': 'Kunden suchen (mind. 3 Zeichen)',
      'personne_a_contacter': 'Kundenkontakt',
      'personne_a_contacter_chez': 'Kontakt bei {{raison_sociale}}',
      'selectionner_contact': 'Kontakt auswählen',
      'message': 'Nachricht',
      'message_placeholder': 'Schreiben Sie Ihre Nachricht...',
      'erreur_recherche_client': 'Suchfehler',
      'aucun_client_trouve': 'Kein Kunde gefunden',
      'aucun_contact_disponible': 'Kein Kontakt für diesen Kunden verfügbar',
      'erreur_creation': 'Fehler beim Erstellen des Gesprächs',
      'conversation_avec': 'Gespräch mit {{raison_sociale}}',
      'chez': 'bei',
      'hier': 'Gestern',
      'conversations_en_cours': 'conversation_one in Bearbeitung',
      'conversations_en_cours_one': 'Gespräch in Bearbeitung',
      'conversations_en_cours_other': 'Gespräche in Bearbeitung',
      'aucune_conversation': 'Kein Gespräch in Bearbeitung.',
      'aucune_conversation_terminee': 'Kein beendetes Gespräch.',
      'selectionner_conversation': 'Wählen Sie ein Gespräch',
      'sans_titre': 'Ohne Titel',
      'cloturer': 'Gespräch beenden',
      'aucun_message': 'Keine Nachrichten in diesem Gespräch.',
      'zone_saisie_placeholder': 'Eingabebereich (kommt bald)',
      'participant_commercial': '{{nom}} (Vertrieb)',
      'placeholder_message': 'Ihre Nachricht eingeben',
      'conversation_terminee_info': 'Dieses Gespräch wurde beendet. Sie können es durch Senden einer Nachricht wieder öffnen.',
      'envoyer': 'Senden',
      'ajouter_piece_jointe': 'Dokument hinzufügen',
      'ajouter_image': 'Bild hinzufügen',
      'piece_jointe': 'Anhang (optional)',
      'taille_fichier_ko': '{{taille}} KB',
      'format_non_supporte': 'Dateiformat "{{nom}}" wird nicht unterstützt (akzeptierte Formate: JPEG, PNG, GIF, WebP, PDF, Word, Excel)',
      'modifier_titre': 'Titel bearbeiten',
      'inviter_collaborateur': 'Mitarbeiter einladen',
      'collaborateur': 'Mitarbeiter',
      'rechercher_collaborateur': 'Mitarbeiter suchen...',
      'aucun_collaborateur_trouve': 'Kein Mitarbeiter gefunden',
      'aucun_collaborateur_disponible': 'Kein Mitarbeiter verfügbar',
      'message_invitation': 'Nachricht (optional)',
      'message_invitation_placeholder': 'Persönliche Nachricht (optional)',
      'collaborateur_sans_email': 'Der ausgewählte Mitarbeiter hat keine registrierte E-Mail-Adresse. Er wird keine Einladungs-E-Mail erhalten.',
      'inviter': 'Einladen',
      'en_cours': 'In Bearbeitung',
      'terminees': 'Abgeschlossen',
      'conversations_suivantes': 'Nächste Gespräche anzeigen',
      'toutes_les_conversations': 'Alle Gespräche',
      'mes_conversations': 'Meine Gespräche',
      'conversations_terminees': 'Abgeschlossene Gespräche',
      'lecture_seule': 'Sie sehen dieses Gespräch im Nur-Lese-Modus',
      'contact_inconnu': 'Unbekannter Kontakt',
      'contact_inconnu_tooltip': 'Dieser Kontakt ist nicht mehr mit diesem Unternehmen verbunden',
      'utilisateur_inconnu': 'Unbekannter Benutzer',
      'utilisateur_inconnu_tooltip': 'Dieser Mitarbeiter ist nicht mehr verfügbar',
      'rejoindre_conversation': 'Dem Gespräch beitreten',
      'vous_avez_rejoint': 'Sie sind dem Gespräch beigetreten'
    },
    'operations_commerciales': {
      'succee_dupliquer': 'Kommerzielle Aktion erfolgreich dupliziert',
      'succee_modifier': 'Kommerzielle Aktion erfolgreich geändert',
      'succee_archiver': 'Kommerzielle Aktion erfolgreich archiviert',
      'ajouter_article': 'Artikel hinzufügen',
      'article_ajoute': 'Artikel erfolgreich hinzugefügt',
      'erreur_ajout': 'Fehler beim Hinzufügen des Artikels',
      'article_obsolete': 'Veraltet',
      'article_reserve': 'Reserviert für {{codes}}',
      'article_reserve_hors_beneficiaires': 'Keine der begünstigten Niederlassungen dieser Aktion gehört zu den Gesellschaften, für die dieser Artikel reserviert ist',
      'buttons': {
        'creer': 'Neue Aktion',
        'publier': 'Veröffentlichen',
        'archiver': 'Archivieren',
        'ajouter_article': 'Hinzufügen',
        'deja_ajoute': 'Bereits hinzugefügt',
      },
      'creation': {
        'succee': 'Aktion erfolgreich erstellt',
        'erreur_info': 'Fehler beim Erstellen der kommerziellen Aktion'
      },
      'modification': {
        'chargement': 'Laden der Informationen zur kommerziellen Aktion',
        'lecture_seule_nationale': 'Nationale Aktion: Sie sehen sie schreibgeschützt. Nur berechtigte Personen können sie bearbeiten.',
        'lecture_seule': 'Sie sehen diese Aktion schreibgeschützt.',
        'lecture_seule_archivee': 'Archivierte Aktion: Sie ist schreibgeschützt. Duplizieren Sie sie, um sie wiederzuverwenden.',
        'sauvegarde_automatique': 'Änderungen werden automatisch gespeichert',
      },
      'modale_filiales': {
        'titre': 'Niederlassungen hinzufügen',
        'rechercher': 'Niederlassung suchen…',
        'disponibles': 'Verfügbare Niederlassungen',
        'toutes': 'Alle',
        'toutes_info': 'Alle angezeigten Niederlassungen auswählen',
        'nombre_disponibles_one': '{{count}} Niederlassung',
        'nombre_disponibles_other': '{{count}} Niederlassungen',
        'nombre_selectionnees_one': '{{count}} Niederlassung ausgewählt',
        'nombre_selectionnees_other': '{{count}} Niederlassungen ausgewählt',
        'aucun_resultat': 'Keine Niederlassung entspricht Ihrer Suche.',
      },
      'modale_langues': {
        'titre': 'Sprache hinzufügen',
      },
      'modale_couleur': {
        'titre': 'Farbe auswählen',
        'appliquer': 'Anwenden',
        'palette': 'Farben der Palette',
        'hex_label': '#',
        'rouge_label': 'R',
        'vert_label': 'G',
        'bleu_label': 'B',
        'hex_aria': 'Hexadezimaler Farbcode',
        'rouge_aria': 'Rotanteil, von 0 bis 255',
        'vert_aria': 'Grünanteil, von 0 bis 255',
        'bleu_aria': 'Blauanteil, von 0 bis 255',
      },
      'modale_cadrage': {
        'titre': 'Bildausschnitt anpassen',
        'enregistrer': 'Speichern',
        'tourner_gauche': 'Bild um eine Vierteldrehung nach links drehen',
        'tourner_droite': 'Bild um eine Vierteldrehung nach rechts drehen',
        'erreur_chargement':
          'Das Bild konnte nicht geladen werden: dieser Bereich behält seinen aktuellen Ausschnitt.',
        'aria_zone': 'Ausschnittbereich: mit den Pfeiltasten verschieben',
        'aria_poignee_nw':
          'Griff oben links: mit den Pfeiltasten Größe ändern',
        'aria_poignee_ne':
          'Griff oben rechts: mit den Pfeiltasten Größe ändern',
        'aria_poignee_se':
          'Griff unten rechts: mit den Pfeiltasten Größe ändern',
        'aria_poignee_sw':
          'Griff unten links: mit den Pfeiltasten Größe ändern',
      },
      'modale_sous_metiers': {
        'titre': 'Teilbranchen von {{metier}}',
        'nombre_selectionnes_one': '{{count}} Teilbranche ausgewählt',
        'nombre_selectionnes_other': '{{count}} Teilbranchen ausgewählt',
      },
      'langue': {
        'fr': 'Französisch',
        'en': 'Englisch',
        'de': 'Deutsch',
      },
      'portee': {
        'locale': 'Lokal',
        'nationale': 'National',
      },
      'modale_portee': {
        'titre': 'Neue kommerzielle Aktion',
        'locale_description': 'Kann von allen begünstigten Niederlassungen bearbeitet werden.',
        'nationale_description': 'Kann nur von berechtigten Personen bearbeitet werden. Die begünstigten Niederlassungen sehen sie schreibgeschützt.',
        'info': 'Die Reichweite kann danach nicht mehr geändert werden.',
        'creer': 'Erstellen',
      },
      'modale_archivage': {
        'titre': 'Aktion archivieren',
        'message': 'Die Aktion wird den Kunden nicht mehr angezeigt und kann nicht wiederhergestellt werden. Ein Jahr lang bleibt sie über „Archivierte Aktionen anzeigen“ in der Liste sichtbar und kann dupliziert werden.',
      },
      'form_info': {
        'operation_info': 'Über die Aktion',
        'nom_label': 'Name der Aktion',
        'nom_placeholder': 'Name der Aktion',
        'description_label': 'Beschreibung der Aktion',
        'description_placeholder': 'Beschreiben Sie die Aktion in wenigen Worten',
        'banniere_label': 'Banner',
        'banniere_info_text_part1': 'Das Bild muss aus der zugänglichen France Frais Medienbibliothek stammen',
        'banniere_info_text_link': 'hier',
        'banniere_info_tooltip': 'Wenn Sie keinen Zugriff auf die Medienbibliothek haben, können Sie diesen bei {{email}} anfordern',
        'visuels_label': 'Visuelle Elemente der Aktion',
        'ordre_label': 'Anzeigereihenfolge',
        'metier_label': 'Branchen',
        'visibilite_label': 'Sichtbarkeit',
        'ciblage_label': 'Zielgruppe',
        'filiales_label': 'Von der Aktion profitierende Niederlassungen',
        'filiales_info': 'Die Kunden jeder ausgewählten Niederlassung sehen die Aktion. Es werden nur Niederlassungen aus Ihrem Zuständigkeitsbereich angeboten.',
        'filiale_hors_perimetre': 'Niederlassung außerhalb Ihres Zuständigkeitsbereichs, Sie können sie nicht entfernen.',
        'filiale_retirer': 'Niederlassung entfernen',
        'filiale_derniere': 'Eine Aktion muss mindestens einer Niederlassung zugutekommen.',
        'ajouter_filiale': 'Niederlassung hinzufügen',
        'voir_toutes_les_filiales': 'Alle Niederlassungen anzeigen ({{count}})',
        'sous_metier_label': 'Anvisierte Teilbranchen',
        'sous_metier_info': 'Ohne ausgewählte Teilbranche zielt die Aktion auf die gesamte Branche. Andernfalls nur auf die ausgewählten Teilbranchen.',
        'ajouter_sous_metier': 'Teilbranche hinzufügen',
        'article_liste_label': 'Produktliste',
        'ajouter_produits': 'Produkte hinzufügen',
        'ajouter_produits_directement': 'Produkte direkt hinzufügen',
        'aucun_produit': 'Noch kein Produkt',
        'traduction_label': 'Übersetzung',
        'ajouter_langue': 'Sprache hinzufügen',
        'article_deja_present': "Der Artikel '{{code_article}}' wurde bereits hinzugefügt",
        'article_inexistant': "Der Artikel '{{code_article}}' existiert nicht",
        'apercu_label': 'Vorschau',
        'apercu_ordinateur': 'Desktop',
        'apercu_mobile': 'Mobil',
        'ajuster_cadrage': 'Bildausschnitt anpassen',
        'reinitialiser_cadrage': 'Bildausschnitt zurücksetzen',
        'compteur_caracteres': '{{longueur}}/{{max_length}}',
        'langue_retirer': 'Sprache entfernen',
        'image_ordinateur': 'Desktop-Bild',
        'image_mobile': 'Mobilbild',
        'format_recommande': 'Empfohlenes Format: 1920×1080 px JPG, PNG, WEBP • Max. 5 MB',
        'glisser_ou_importer': 'Bild hierher ziehen oder importieren',
        'couleur_banniere_label': 'Farbe des Banners auswählen',
        'choisir_couleur': 'Farbe {{couleur}}',
        'ajouter_couleur': 'Andere Farbe auswählen',
        'remplacer_image': 'Ersetzen',
        'retirer_image': 'Bild entfernen',
        'envoi_image_en_cours': 'Bild wird hochgeladen...',
        'plage_date_label': 'Zeitraum',
        'selectionner_periode': 'Zeitraum auswählen',
        'plage_date_info': 'Der Zeitraum, in dem die Aktion den Kunden angezeigt wird. Ohne Zeitraum wird die Aktion nicht angezeigt.',
        'affiche_date_fin_label': 'Enddatum der Aktion den Kunden anzeigen'
      },
      'columns': {
        'nom': 'Aktion',
        'ordre': 'Reihenfolge',
        'statut': 'Status',
        'statut_info': {
          'visible': 'Sichtbar: im Zeitraum wird die Aktion den Zielkunden angezeigt.',
          'masquee': 'Ausgeblendet: ohne Zeitraum oder außerhalb des Zeitraums (vorbei oder künftig) wird sie keinem Kunden angezeigt.',
          'archivee': 'Archiviert: Sie wird keinem Kunden angezeigt und kann nicht mehr bearbeitet, aber dupliziert werden. Ein Jahr nach der Archivierung verschwindet sie aus der Liste.',
        },
        'portee': 'Reichweite',
        'portee_info': 'National: kann nur von berechtigten Personen bearbeitet werden, die begünstigten Niederlassungen sehen sie schreibgeschützt. Lokal: kann von allen begünstigten Niederlassungen bearbeitet werden.',
        'articles': 'Artikel',
        'destinataires': 'Empfänger',
        'actions': 'Aktionen',
        'plage_date': 'Zeitraum'
      },
      'statut': {
        'publiee': 'Sichtbar',
        'depubliee': 'Ausgeblendet',
        'archivee': 'Archiviert',
      },
      'chercher_operation': 'Aktion suchen…',
      'effacer_recherche': 'Suche löschen',
      'aucune_operation': 'Keine Aktion anzuzeigen.',
      'voir_archivees': 'Archivierte Aktionen anzeigen',
      'nombre_metiers': '{{count}} Branche',
      'nombre_metiers_one': '{{count}} Branche',
      'nombre_metiers_other': '{{count}} Branchen',
      'aucun_metier': 'Keine Branche',
      'sous_metiers_du_metier': '{{metier}}: {{sous_metiers}}',
      'articles': {
        'un': '{{nb_produits}} Artikel',
        'plusieurs': '{{nb_produits}} Artikel'
      },
      'actions': {
        'publier': 'Veröffentlichen',
        'dupliquer': 'Duplizieren',
        'archiver': 'Archivieren',
        'erreur_info': 'Fehler bei der Aktion: {{scope}}'
      },
      'plage_date_courte': '{{date_debut}} - {{date_fin}}'
    },
    'pdf_import': {
      'status': {
        'searching': 'Suche...',
        'matched_ok': 'Gefunden',
        'not_found': 'Nicht im Katalog gefunden',
        'error': 'Fehler bei der Suche'
      },
      'mismatch': {
        'code': 'Artikelcode unterscheidet sich vom Katalog',
        'name': 'Bezeichnung unterscheidet sich vom Katalog'
      },
      'table': {
        'status': 'Status',
        'catalog_code': 'Katalogcode',
        'catalog_name': 'Katalogbezeichnung',
        'pdf_code': 'Code (aus PDF)',
        'pdf_name': 'Bezeichnung (aus PDF)',
        'pdf_qty': 'Menge (aus PDF)',
        'pdf_unit': 'Einheit (aus PDF)',
        'pdf_unit_price': 'EP (aus PDF)'
      },
      'success_parse': 'PDF erfolgreich analysiert',
      'error_invalid_type': 'Ungültiges Dateiformat',
      'error_no_file': 'Keine Datei ausgewählt',
      'error_client_not_ready': 'Kunde nicht ausgewählt',
      'parsing_pdf': 'PDF wird analysiert ...',
      'title': 'Eine PDF-Bestellung importieren',
      'no_clients_available': 'Keine Kunden verfügbar',
      'select_client_placeholder': 'Einen Kunden auswählen...',
      'no_clients_found': 'Kein Kunde gefunden',
      'error_fetching_clients': 'Fehler beim Abrufen der Kunden',
      'file_label': 'PDF-Datei der Bestellung',
      'effacer_fichier': 'Datei löschen',
      'submit_button': 'PDF analysieren',
      'error_submission': 'Fehler beim Analysieren der PDF.',
      'error_loading_index': 'Fehler beim Laden des Kundenkatalogs.',
      'loading_index': 'Lade Suchindex...',
      'searching_items': 'Suche nach Artikeln...',
      'results_title': 'Ergebnisse der PDF-Analyse',
      'delivery_date': 'Lieferdatum',
      'delivery_address': 'Lieferadresse',
      'order_reference': 'Bestellreferenz',
      'import_another': 'Eine andere Datei importieren',
      'export_xlsx': 'Als Tabelle exportieren',
      'search_client_label': 'Einen Kunden suchen'
    },
    'pdf_order_import': {
      'title': 'PDF-Bestellungen importieren',
      'nouvel_import': 'Neuer Import',
      'chercher_client': 'Einen Kunden suchen',
      'uniquement_echecs': 'Nur Fehlschläge',
      'aucun_processus_trouve': 'Kein Prozess gefunden',
      'recherche_client': 'Kundensuche',
      'placeholder_recherche_client': 'Geben Sie den Kundennamen oder Code ein (min. 3 Zeichen)',
      'chargement_societe': 'Laden der Firmendaten...',
      'erreur_chargement_societe': 'Fehler beim Laden der Firmendaten',
      'client_selectionne': 'Ausgewählter Kunde',
      'changer': 'Ändern',
      'recherche': 'Suche...',
      'erreur_recherche_clients': 'Fehler bei der Kundensuche',
      'aucun_client_trouve': 'Kein Kunde gefunden',
      'id': 'ID',
      'fichier_pdf': 'PDF-Datei',
      'erreur_fichier_pdf': 'Die Datei muss eine PDF sein',
      'veuillez_selectionner_pdf': 'Bitte wählen Sie eine PDF-Datei aus',
      'fichier_invalide': 'Die Datei muss vom Typ {{types}} sein',
      'cliquez_ou_glissez_document': 'Klicken Sie hier oder ziehen Sie das Dokument hierher',
      'cliquez_ou_glissez_documents': 'Klicken Sie hier oder ziehen Sie die Dokumente hierher',
      'formats_acceptes': '{{formats}}',
      'processus_initie_succes': 'Prozess erfolgreich gestartet',
      'importer': 'Importieren',
      'rapport': 'Bericht:',
      'voir_details': 'Details ansehen',
      'nom_fichier': 'Dateiname:',
      'taille_fichier': 'Dateigröße:',
      'taille_fichier_ko': '{{taille}} KB',
      'reference_pdf': 'PDF-Referenz:',
      'erreur_chargement_processus': 'Fehler beim Laden des Prozesses',
      'date_initiation': 'Startdatum',
      'par': 'von {{utilisateur}}',
      'detail_processus': 'Prozessdetails',
      'statut': 'Status:',
      'cree_le': 'Erstellt am:',
      'mis_a_jour_le': 'Aktualisiert am:',
      'modifier_panier': 'Zum Warenkorb gehen',
      'transformer_en_panier': 'In Warenkorb umwandeln',
      'redemarrer_matching': 'Matching neu starten',
      'redemarrer_matching_avec_client': 'Matching mit diesem Kunden neu starten',
      'corriger_client': 'Kunde korrigieren und Matching neu starten',
      'erreur_detectee': 'Fehler erkannt:',
      'etape_non_executee': 'Schritt noch nicht ausgeführt',
      'voir_fichier_pdf': 'PDF-Datei ansehen',
      'resultat_badge': {
        'ok': 'OK',
        'echec': 'Fehlgeschlagen ({{nombre}}/{{total}})',
        'en_cours': 'In Bearbeitung',
        'archive': 'Gelöscht',
        'commande_validee': 'Bestellung bestätigt',
        'panier': 'Warenkorb',
        'non_defini': '-'
      },
      'etape': {
        'capture': 'Erfassung',
        'extract': 'Extraktion',
        'match': 'Abgleich',
        'controle': 'Kontrolle',
        'panier': 'Warenkorb',
        'statut': {
          'terminee': 'OK',
          'echouee': 'KO',
          'en_cours': 'In Bearbeitung',
          'non_defini': '-'
        }
      },
      'relancer_processus': 'Prozess neu starten',
      'processus_relance_succes': 'Prozess erfolgreich neu gestartet',
      'processus_transforme_panier': 'Prozess in Warenkorb umgewandelt',
      'matching_redemarre_succes': 'Matching erfolgreich neu gestartet',
      'archiver_processus': 'Löschen',
      'processus_archive_succes': 'Der Prozess wurde gelöscht',
      'archiver_confirmation': {
        'titre': 'Diesen Import löschen?',
        'texte':
          'Der Import und seine PDF-Datei werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
        'titre_avec_panier': 'Diesen Import und seinen Warenkorb löschen?',
        'texte_avec_panier':
          'Der aus diesem Import erstellte Warenkorb wird mit allen Positionen gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
        'valider_avec_panier': 'Import und Warenkorb löschen',
      },
      'filtre': {
        'mes_imports': 'Meine Importe',
        'initie_par': 'Gestartet von',
        'client': 'Kunde',
        'statut': 'Status',
        'statut_en_cours': 'In Bearbeitung',
        'statut_erreur': 'Fehler',
        'statut_panier': 'Warenkorb',
        'statut_commande_validee': 'Bestellung bestätigt',
      },
      'columns': {
        'date_reception_id': 'EMPFANGSDATUM / PDF',
        'lance_par': 'INITIIERT VON',
        'client': 'KUNDE',
        'statut': 'STATUS'
      },
      'extract': {
        'erreur_plusieurs_commandes': 'Das PDF enthält mehrere unterschiedliche Liefertermine',
        'erreur_qualite_insuffisante': 'Die PDF-Dateiqualität ist unzureichend, um Daten zu extrahieren',
        'erreur_annotations_manuscrites': 'Das PDF enthält handschriftliche Anmerkungen',
        'erreur_pas_une_commande': 'Das Dokument ist kein Bestellschein',
        'erreur_annulation_article': 'Das Dokument ist eine Stornierungsanfrage',
        'erreur_demande_avoir': 'Das Dokument ist eine Gutschriftsanfrage',
        'erreur_aucune_ligne': 'Keine Produktzeile wurde aus dem PDF extrahiert',
        'voir_donnees_extraites': 'Extrahierte Daten anzeigen',
        'nom_client': 'Kundenname',
        'numero_client': 'Kundennummer',
        'code_ur_client': 'UR-Code',
        'date_de_livraison': 'Lieferdatum',
        'adresse_de_livraison': 'Lieferadresse',
        'numero_bon_commande': 'Bestellreferenz',
        'date_creation': 'Erstellungsdatum',
        'destinataire': 'Empfänger',
        'nombre_lignes': 'Anzahl der Zeilen',
        'autres_informations': 'Weitere Informationen',
        'non_renseigne': 'Nicht angegeben',
        'adresse_emetteur': 'Absenderadresse',
        'adresse_facturation': 'Rechnungsadresse',
        'contact_emetteur': 'Absenderkontakt',
        'contact_adresse_livraison': 'Lieferadressenkontakt',
        'contact_adresse_facturation': 'Rechnungsadressenkontakt',
        'informations_de_livraison': 'Lieferinformationen',
        'signature_client': 'Kundenunterschrift',
        'prix_total': 'Gesamtpreis',
        'lignes': 'Produktzeilen',
        'nom': 'Name',
        'prenom': 'Vorname',
        'email': 'E-Mail',
        'telephone': 'Telefon',
        'fonction': 'Funktion',
        'point_livraison_specifique': 'Spezifischer Lieferpunkt',
        'horaire_livraison_specifique': 'Spezifische Lieferzeit',
        'autres_informations_livraison': 'Weitere Lieferinformationen',
        'nom_prenom': 'Vollständiger Name',
        'date': 'Datum',
        'total_ht': 'Gesamtpreis exkl. MwSt.',
        'total_tva': 'Gesamtpreis MwSt.',
        'total_ttc': 'Gesamtpreis inkl. MwSt.',
        'numero_ligne_pdf': 'PDF-Zeilennummer',
        'texte_entree': 'Originaltext',
        'code_article_extrait': 'Produktcode',
        'libelle_extrait': 'Bezeichnung',
        'quantite_commandee': 'Menge',
        'coefficient_commande_client_vers_facturation': 'Koeffizient',
        'unite_commande': 'Bestelleinheit',
        'unite_facturation': 'Rechnungseinheit',
        'prix_unitaire_extrait': 'Einzelpreis',
        'prix_total_extrait': 'Gesamtpreis',
        'marque_extraite': 'Marke',
        'exception_plusieurs_commandes': 'Mehrere Bestellungen',
        'exception_qualite_suffisante': 'Ausreichende Qualität',
        'exception_annotations_manuscrites': 'Handschriftliche Anmerkungen',
        'exception_est_une_commande': 'Ist eine Bestellung',
        'exception_annulation_article_commande_passee': 'Stornierungsanfrage für vergangene Bestellung',
        'exception_demande_avoir': 'Gutschriftsanfrage',
        'exception_prix_total_incoherent': 'Inkonsist Gesamtpreis',
        'siret_client': 'SIRET Kunde',
        'format_pdf': 'PDF-Format',
        'confiance_metadata': 'Metadaten',
        'confiance_text': 'Text',
        'confiance_fallback': 'Heuristik',
      },
      'match': {
        'exception': {
          'qualite_insuffisante': 'Die Qualität der PDF-Datei ist unzureichend',
          'annotations_manuscrites':
            'Das PDF enthält handschriftliche Anmerkungen',
          'pas_une_commande': 'Das Dokument ist keine Bestellung',
          'demande_avoir': 'Das Dokument ist eine Gutschriftsanforderung',
          'annulation_commande': 'Das Dokument ist eine Stornierungsanfrage',
          'plusieurs_commandes': 'Das PDF enthält mehrere Lieferdaten',
          'aucune_ligne_extraite': 'Es wurde keine Produktzeile extrahiert',
          'prix_total_incoherent':
            'Die Summe der Zeilen weicht vom Gesamtbetrag ab.',
          'fichier_doublon':
            'Datei bereits am {{date_doublon}} um {{heure_doublon}} verarbeitet, initiiert von {{utilisateur_initiateur}}.',
          'fichier_doublon_lien': 'Prozess anzeigen',
          'client_non_matche': 'Kein passender Kunde gefunden',
        },
        'exceptions_titre': 'Warnungen und Ausnahmen',
        'client_titre': 'Kunde',
        'client_code': 'Kundencode',
        'client_raison_sociale': 'Firmenname',
        'date_de_livraison': 'Lieferdatum',
        'date_extraite': 'Extrahiertes Datum',
        'date_matchee': 'Zugeordnetes Datum',
        'date_valide': 'Gültiges Datum',
        'date_invalide': 'Ungültiges Datum',
        'date_livraison.validee': 'Lieferdatum extrahiert und validiert',
        'date_livraison.aucune_tournee_correspond': 'Keine Liefertour entspricht dem vom Kunden angegebenen Datum.',
        'date_livraison.date_inferieure_aujourdhui': 'Das vom Kunden angegebene Lieferdatum liegt vor dem heutigen Tag',
        'date_livraison.absente': 'Kein Lieferdatum auf der Bestellung: Die erste verfügbare Liefertour wurde übernommen.',
        'adresse_de_livraison': 'Lieferadresse',
        'adresse_extraite': 'Extrahierte Adresse',
        'adresse_matchee': 'Zugeordnete Adresse',
        'aucune_adresse_matchee': 'Keine Adresse zugeordnet',
        'mode_unique': 'Eindeutige Kundenadresse',
        'mode_bm25': 'BM25-Zuordnung',
        'mode_default': 'Standardauswahl',
        'adresse_non_verifiee': 'Adresse nicht verifiziert - niedrige Übereinstimmung',
        'etat_badge_ok': 'OK',
        'etat_badge_alerte': 'Zu prüfen',
        'etat_badge_bloquant': 'Vorrangig prüfen',
        'adresse_ok': 'Adresse validiert',
        'adresse_alerte': 'Adresse zu überprüfen',
        'adresse_bloquant': 'Adresse in Tolède zu validieren',
        'statistiques': 'Statistiken',
        'lignes_ok': 'OK-Zeilen',
        'lignes_avertissement': 'Zu prüfen',
        'lignes_bloquant': 'Vorrangig prüfen',
        'lignes': 'Bestellzeilen',
        'aucune_ligne': 'Keine Zeilen',
        'code_deduit': 'Abgeleiteter Code',
        'code_exact': 'Exakter Code',
        'libelle_different': 'Unterschiedliche Bezeichnung',
        'quantite_incoherente': 'Inkohärente Menge',
        'quantite_incoherente_detail': 'Vielfaches: {{multiple}}, PDF-Menge: {{quantite_pdf}}',
        'quantite_ajustee_suggestion': 'Vorgeschlagen: {{quantite_ajustee}}',
        'prix_different': 'Unterschiedlicher Preis ({{ecart}}%)',
        'unite_incoherente': 'Inkohärente Einheit',
        'unite_incoherente_detail': '{{unite_pdf}} → {{unite_catalogue}}',
        'unite_inconnue': 'Unbekannt',
        'unite_raison_incompatible_units': 'Inkompatible Einheiten',
        'unite_raison_unknown_unit': 'Einheit im PDF nicht erkannt',
        'unite_raison_regle_de_trois_ok': 'Akzeptiert (Dreisatz OK)',
        'hors_cadencier': 'Außerhalb des Preisverzeichnisses',
        'dans_cadencier': 'Im Preisverzeichnis',
        'article_non_trouve': 'Artikel nicht gefunden',
        'donnees_pdf': 'PDF-Daten',
        'prix_pdf': 'PDF-Preis',
        'prix_catalogue': 'Katalogpreis',
        'libelle_pdf': 'PDF-Bezeichnung',
        'libelle_catalogue': 'Katalogbezeichnung',
        'similarite': 'Ähnlichkeit',
        'faible_similarite': 'Geringe Ähnlichkeit',
        'comparaison_libelle': 'Bezeichnungsvergleich',
        'score_tooltip': 'Vertrauen: {{score}}%',
        'nombre_lignes_coherent': 'Anzahl der Zeilen konsistent',
        'nombre_lignes_coherent_tooltip': 'PDF: {{pdf}}, Extrahiert: {{extraites}}',
        'nombre_lignes_incoherent': 'PDF: {{pdf}}, Extrahiert: {{extraites}}',
        'prix_total_titre': 'Gesamtpreis',
        'prix_total_pdf': 'PDF-Preis (exkl. MwSt.)',
        'prix_total_pdf_ttc': 'PDF-Preis (inkl. MwSt.)',
        'prix_total_calcule': 'Berechneter Preis',
        'prix_total_coherent': 'Beträge konsistent',
        'prix_total_incoherent': 'Abweichung von {{ecart}}%',
        'voir_comparaison_detaillee': 'Detaillierten Datenvergleich anzeigen',
        'colonne_champ': 'Feld',
        'colonne_valeur_pdf': 'PDF-Wert',
        'colonne_valeur_matchee': 'Ableitung',
        'colonne_statut': 'Ergebnis',
        'champ_texte_entree': 'Rohinformation',
        'champ_code_article': 'Artikelcode',
        'champ_libelle': 'Bezeichnung',
        'champ_unite_commande': 'Bestelleinheit',
        'champ_unite_facturation': 'Abrechnungseinheit',
        'champ_quantite': 'Menge',
        'champ_prix_unitaire': 'Einzelpreis',
        'champ_prix_total': 'Gesamtpreis',
        'champ_cadencier': 'Im Preisverzeichnis',
        'code_article_client_info': 'Kundencode: {{code}}',
        'code_generique_info': 'Generischer Code: {{code}}',
        'quantite_multiple_info': 'Bestellvielfaches: {{multiple}}',
        'ligne_colonne_numero': 'Nr.',
        'ligne_colonne_code': 'Code',
        'ligne_colonne_libelle': 'Bezeichnung',
        'ligne_colonne_qte': 'Menge',
        'ligne_colonne_prix_u': 'Einzelpreis',
        'ligne_colonne_prix_ligne': 'Zeilenpreis',
        'badge_code': 'Code',
        'badge_code_exact': 'Exakt',
        'badge_code_non_trouve': 'Nicht gefunden',
        'badge_code_manquant': 'Fehlt',
        'badge_libelle': 'Bezeichnung',
        'badge_libelle_exact': 'Exakt',
        'badge_libelle_partiel': 'Teilweise',
        'badge_libelle_non_reconnu': 'Nicht erkannt',
        'badge_prix_ligne': 'Zeilenpreis',
        'badge_prix_ligne_ok': 'OK',
        'badge_prix_ligne_alerte': 'Warnung',
        'badge_prix_ligne_ko': 'Inkonsistent',
        'badge_prix_unitaire': 'Stückpreis',
        'badge_dans_cadencier': 'Im Zeitplan',
        'badge_hors_cadencier': 'Außerhalb des Zeitplans',
        'tooltip_similarite': 'Ähnlichkeit: {{score}}%',
        'tooltip_ecart': 'Abweichung: {{ecart}}%',
        'client_mode_auto': 'Automatische Erkennung',
        'client_mode_preselectionne': 'Vorgewählt',
        'client_confiance': 'Vertrauen',
        'client_donnees_extraites': 'Aus PDF extrahierte Daten',
        'client_donnees_matchees': 'Identifizierter Kunde',
        'client_siret': 'SIRET',
        'client_numero': 'Kundennummer',
        'client_nom': 'Kundenname',
        'client_adresse_livraison': 'Lieferadresse',
        'client_adresse_facturation': 'Rechnungsadresse',
        'client_etapes_matching': 'Zuordnungsschritte',
        'client_candidats': 'Kandidaten',
        'client_candidats_restants': '{{count}} Kandidat(en)',
        'client_candidats_partial': 'Kandidaten ({{displayed}} von {{total}})',
        'client_candidats_all': 'Kandidaten ({{total}})',
        'client_score': 'Punktzahl',
        'client_criteres': 'Zugeordnete Kriterien',
        'client_non_renseigne': 'Nicht angegeben',
        'client_valeur_recherchee': 'Gesuchter Wert',
        'critere_utilise': {
          'siret': 'SIRET',
          'code_client': 'Kundencode',
          'adresses_livraison_facturation': 'Liefer-/Rechnungsadressen',
          'raison_sociale': 'Firmenname'
        },
        'critere_match': {
          'siret_exact': 'Exakte SIRET',
          'numero_client_exact': 'Exakte Kundennummer',
          'adresse_bm25': 'Adresse (BM25)',
          'nom_bm25': 'Name (BM25)'
        },
        'tooltip': {
          'etat_final': 'Endergebnis: {{etat}}',
          'identification': 'Identifizierung: {{etat}}',
          'code_detail': '• Code: {{etat}} {{valeur}}',
          'libelle_detail': '• Bezeichnung: {{etat}}',
          'prix_ligne_detail': 'Zeilenpreis: {{etat}}',
          'etat': {
            'ok': 'OK',
            'alerte': 'WARNUNG',
            'bloquant': 'BLOCKIEREND'
          },
          'code': {
            'exact': 'EXAKT',
            'non_trouve': 'NICHT GEFUNDEN',
            'manquant': 'FEHLEND'
          },
          'libelle': {
            'exact': 'EXAKT ({{percentage}}%)',
            'partiel': 'TEILWEISE ({{percentage}}%)',
            'non_reconnu': 'NICHT ERKANNT ({{percentage}}%)'
          },
          'prix': {
            'ok': 'OK',
            'alerte': 'WARNUNG ({{ecart}})',
            'ko': 'KO ({{ecart}})',
            'vide': 'Kein Preis zum Vergleichen'
          },
          'regle': {
            'prix_absent': 'Kein Preis zum Vergleichen → WARNUNG',
            'prix_bloquant': 'Zeilenpreis > {{threshold}}% → BLOCKIEREND',
            'code_exact_libelle_ok': 'Code EXAKT + Bezeichnung OK → OK',
            'code_exact_libelle_ko': 'Code EXAKT + Bezeichnung KO → BLOCKIEREND (verdächtiger Konflikt)',
            'libelle_exact_compense_code': 'Bezeichnung EXAKT kompensiert fehlenden Code → OK',
            'pas_code_libelle_partiel': 'Kein Code + Bezeichnung TEILWEISE → WARNUNG',
            'ni_code_ni_libelle': 'Weder Code noch zuverlässige Bezeichnung → BLOCKIEREND',
            'prix_alerte': 'Zeilenpreis ≤ {{threshold}}% → WARNUNG',
            'evaluation_standard': 'Standardbewertung'
          }
        }
      }
    },
    'roadmap': {
      'toast': {
        'success': 'Die Roadmap wurde aktualisiert'
      },
      'acceder': 'Zur Roadmap FFConnect / FFCommerce',
      'acces_refuse': 'Zugriff auf die FFConnect-Projektgruppe beschränkt.',
      'vide': 'Noch keine Roadmap veröffentlicht.',
      'edition_titre': 'Roadmap bearbeiten',
      'edition_aide':
        'Fügen Sie unten den vollständigen HTML-Code der Roadmap ein. Er ersetzt den aktuellen Inhalt vollständig.',
      'placeholder': 'Fügen Sie hier den HTML-Code der Roadmap ein…',
      'enregistrer': 'Speichern'
    },
    'changelog': {
      'titleForm': 'FFConnect Änderungsprotokoll',
      'toast': {
        'success': 'Das Änderungsprotokoll wurde erfolgreich erstellt'
      },
      'form': {
        'title': 'Titel',
        'placeholder_title': 'Bsp: Neuigkeiten bei FFConnect',
        'article_id': 'Artikel-ID',
        'date': 'Datum',
        'enregister': 'Speichern'
      }
    },
    'aucune_societe_commerciale': 'Keine Vertriebsgesellschaft verfügbar',
    'vide': 'Keine Elemente',
    'maintenance': {
      'titleForm': 'Wartungsankündigung',
      'form': {
        'date': 'Datum',
        'heure_debut': 'Startzeit',
        'heure_fin': 'Endzeit',
        'commence_le': 'Startdatum und -zeit',
        'termine_le': 'Enddatum und -zeit',
        'commence_le_short': 'Beginnt am',
        'termine_le_short': 'Endet am',
        'message_fr': 'Nachricht (FR)',
        'message_en': 'Nachricht (EN)',
        'message_de': 'Nachricht (DE)',
        'placeholder_message': 'Ihre Nachricht…',
        'jours_avant': 'Wie viele Tage vorher anzeigen (Standard 1)',
        'enregistrer': 'Speichern',
        'creer': 'Wartung erstellen',
        'traduire': 'Ins Englische und Deutsche übersetzen',
      },
      'toast': {
        'success': 'Wartungsankündigung gespeichert',
        'traduction_echouee': 'Die Übersetzung ist fehlgeschlagen. Bitte erneut versuchen.',
      },
      'preview': {
        'titre': 'Bannervorschau',
      }
    }
  },
  'metier': {
    'A1': 'SOZIALE VERPFLEGUNG',
    'A2': 'KOMMERZIELLE VERPFLEGUNG',
    'A3': 'NEU ZUZUORDNEN B1 B2 B3 A2',
    'A4': 'SUPERMÄRKTE',
    'A5': 'NIEDERLASSUNGEN / PERSONAL',
    'A6': 'GROSSHÄNDLER INDUSTRIE',
    'A7': 'NAHVERSORGUNG',
    'B1': 'BVP',
    'B2': 'KÄSEHÄNDLER',
    'B3': 'METZGER FEINKOSTHÄNDLER',
    'B4': 'ANDERE HANDWERKER UND HÄNDLER',
    'E1': 'EXPORT NEU ZU KLASSIFIZIEREN',
    'P1': 'PRIVATPERSONEN'
  },
  'sous_metier': {
    'A1-11': 'Betriebsgastronomie',
    'A1-12': 'Schulen',
    'A1-13': 'Gesundheitswesen',
    'A1-14': 'Soziales',
    'A1-15': 'Freizeit',
    'A1-16': 'Sonstiges',
    'A2-21': 'Bedienung am Tisch',
    'A2-22': 'Cafeteria',
    'A2-23': 'Schnellgastronomie',
    'A2-24': 'Hotel',
    'A2-25': 'Verkehrsgastronomie',
    'A2-26': 'Freizeitgastronomie',
    'A2-27': 'Event-Caterer (ohne Laden)',
    'A2-28': 'Marketplace',
    'A4-41': 'Nahversorgung',
    'A4-42': 'Supermärkte',
    'A4-49': 'Multi-Frische',
    'A4-50': 'Online-Verkauf',
    'A5-51': 'Personalverkauf France Frais',
    'A5-52': 'Niederlassungen',
    'A6-61': 'Großhändler',
    'A6-62': 'Industrie',
    'A6-63': 'Biogasanlage / Entsorger',
    'A6-64': 'Spediteure',
    'A7-1': 'Supermarktkette',
    'A7-2': 'Unabhängiger Nachbarschaftsladen',
    'B1-71': 'Bäcker-Konditor',
    'B1-72': 'Bäcker',
    'B1-73': 'Konditor',
    'B1-74': 'Eismacher',
    'B1-75': 'Aufbackstationen',
    'B1-76': 'Chocolatier',
    'B1-77': 'Supermarkt-Labor',
    'B2-81': 'Käsehändler',
    'B2-82': 'Online-Verkauf',
    'B3-91': 'Metzger',
    'B3-94': 'Online-Verkauf',
    'B3-96': 'Geflügelhändler / Innereien',
    'B3-97': 'Pferdemetzgerei',
    'B3-98': 'Fleischer / Partyservice mit Laden',
    'B3-99': 'Rotisserie',
    'B4-91': 'Feinkost',
    'B4-92': 'Sonstige (Brauer, Kaffeeröster…)',
    'B4-97': 'Fischhändler',
    'B4-98': 'Obst- und Gemüsehändler',
    'B4-99': 'Online-Verkauf',
    'P1-57': 'MLC-Personal',
    'P1-58': 'Online-Privatkunden',
    'P1-59': 'Kundenpersonal',
    'P1-60': 'Brigadiers',
    'P1-61': 'Privatkunden',
  },
  'activation': {
    'aucun_email': 'Keine E-Mail',
    'aucun_email_color': 'red.fail',
    'non_connecte': 'Nicht verbunden',
    'non_connecte_color': 'red.fail',
    'aucun_panier': 'Kein Warenkorb',
    'aucun_panier_color': 'orange.warning',
    'aucune_commande': 'Keine Web-Bestellung',
    'aucune_commande_color': 'orange.warning',
    'actif': 'Aktiv',
    'actif_color': 'green.success',
    'connecte': 'Verbunden',
    'connecte_color': 'green.success',
    'ont_commande': 'Haben bestellt',
    'ont_commande_color': 'green.success'
  },
  'motif_de_blocage': {
    '01': '01 - Schließung der Niederlassung',
    '02': '02 - Nichtzahlung des Kunden',
    '03': '03 - Unbezahlte Rechnung',
    '04': '04 - Kunde einem anderen Mitglied zugewiesen',
    '05': '05 - Wechsel der Zentrale',
    '06': '06 - Verlorener Kunde',
    '07': '07 - Insolvenzverwaltung',
    '08': '08 - Eigentümerwechsel',
    '09': '09 - Zentralkunde (nicht abrechenbar)',
    '10': '10 - Sonstige',
    '11': '11 - Kontenzusammenfassung',
    '12': '12 - Wird dupliziert',
    '13': '13 - Gerichtsvollzieher',
    '14': '14 - Kein Umsatz seit 6 Monaten',
    '15': '15 - Verkaufseinspruch',
    '16': '16 - Coface',
    '17': '17 - Gerichtliche Liquidation',
    '88': '88 - Kreditlimit überschritten',
    '89': '89 - Zahlungsfrist überschritten',
  },
  'jours': {
    'dimanche': 'Sonntag',
    'lundi': 'Montag',
    'mardi': 'Dienstag',
    'mercredi': 'Mittwoch',
    'jeudi': 'Donnerstag',
    'vendredi': 'Freitag',
    'samedi': 'Samstag',
  },
  'mes_informations': {
    'modification_alerte': 'Möchten Sie eine Änderung vornehmen?',
    'contacter_commercial': 'Kontaktieren Sie Ihren Vertriebsmitarbeiter',
    'votre_commercial': 'Ihr Vertriebsmitarbeiter',
    'mes_adresses': 'Meine Adressen',
    'adresses_de_facturation': 'Rechnungsadressen',
    'adresses_de_livraison': 'Lieferadressen',
    'adresse_de_retrait': 'Abholadresse',
    'mon_identite': 'Meine Identität',
    'mon_entreprise': 'Mein Unternehmen',
    'mes_coordonnees': 'Meine Kontaktdaten',
    'numero_de_compte': 'Kontonummer:',
    'siret': 'SIRET:',
    'tva': 'MwSt.:',
    'par_mail': 'Per E-Mail',
    'adresses_enlevement': 'Abholadressen',
    'date_de_livraison': 'Lieferdatum:',
    'cut_off_de_preparation': 'Vorbereitungs-Cut-off:',
    'les_tournees': 'Die Touren',
    'tournee_enlevement': 'Abholtour Nr. {{numero}}',
    'tournee_livrante': 'Liefertour Nr. {{numero}}'
  },
  'contact': {
    'societe_commerciale': 'Vertriebsgesellschaft',
    'televente': 'Telefonverkauf',
    'commercial': 'Vertriebsmitarbeiter',
    'copier_email': 'E-Mail kopieren',
    'non_renseigne': 'Nicht angegeben'
  },
  'commande': {
    'nombre_commandes': '{{count}} BESTELLUNG',
    'nombre_commandes_one': '{{count}} BESTELLUNG',
    'nombre_commandes_other': '{{count}} BESTELLUNGEN',
    'nombre_commandes_many': '{{count}} BESTELLUNGEN',
    'nombre_commandes_plural': '{{count}} BESTELLUNGEN',
    'commande': 'BESTELLUNG',
    'commande_one': 'BESTELLUNG',
    'commande_other': 'BESTELLUNGEN',
    'commande_plural': 'BESTELLUNGEN',
    '2_derniers_mois': 'Die letzten 2 Monate',
    '3_6_mois': '3 bis 6 Monate',
    'en_cours': 'In Bearbeitung',
    'livrees': 'Geliefert',
    'livree': 'Geliefert',
    'annulees': 'Storniert',
    'en_cours_de_traitement': 'In Bearbeitung',
    'voir_le_detail': 'Details ansehen',
    'non_definie': 'Nicht definiert',
    'saisie': 'Erfasst',
    'annulee': 'Storniert',
    'ferme': 'Geschlossen',
    'mise_en_prepa': 'In Vorbereitung',
    'prepa_en_cours': 'Vorbereitung läuft',
    'prepa_terminee': 'Vorbereitung abgeschlossen',
    'facturee': 'Fakturiert',
    'total_ttc': 'Gesamt Brutto',
    'total_ht': 'Gesamt Netto',
    'total_tva': 'Gesamt MwSt.',
    'livraison_du': 'Lieferung vom',
    'commande_du': 'Bestellung vom',
    'commande_marketplace_du': '{{marketplace}}-Bestellung vom',
    'date_de_commande': 'Bestelldatum',
    'passer_nouvelle_commande': 'Eine neue Bestellung aufgeben',
    'contacter_conseiller': 'Meinen Berater kontaktieren',
    'vous_etes_trompe': 'Haben Sie sich geirrt?',
    'on_vous_accompagne': 'Wir begleiten Sie.',
    'bon_de_commande': 'Bestellschein',
    'details_de_ma_commande': 'Details meiner Bestellung',
    'frais_de_livraison': 'Lieferkosten',
    'n°': 'Nr.',
    'documents_non_disponibles': 'Dokumente nicht verfügbar',
    'modale_changer_adresse_header': 'Wählen Sie Ihren Dienst aus',
    'digital': 'France Frais Connect',
    'ancien_web': 'Altes Web',
    'televente': 'Telefonverkauf',
    'commercial': 'Vertriebsmitarbeiter',
    'ffcommerce': 'Vertriebsmitarbeiter (FFC)',
    'article': '{{count}} Artikel',
    'article_one': '{{count}} Artikel',
    'article_other': '{{count}} Artikel',
    'article_many': '{{count}} Artikel',
    'article_plural': '{{count}} Artikel',
    'remplacer_article': '<strong>{{nom}}</strong> ersetzen',
    'chercher_tout_catalogue': 'Im gesamten Katalog suchen',
    'voir_produits_ub': 'Alle Produkte der UB: {{nom}}',
    'chercher_dans_ub': 'In der UB suchen',
    'aucun_produit_ub': 'Kein Produkt entspricht Ihrer Suche',
    'remplacement_aucun_article': 'Leider wurde kein Ersatzartikel gefunden',
    'remplacement_aucun_produit_marche':
      'Kein Marktprodukt gefunden. Deaktivieren Sie den Filter „Marktprodukte“, um andere Artikel zu sehen.',
    'remplacement_aucun_filtre':
      'Kein Artikel entspricht den Filtern oder der Suche.',
    'par_multiple': 'pro {{quantite}} {{unite}}',
    'par_colis': 'pro Paket von {{quantite}} {{unite}}',
    'de_multiple_facturation': 'von {{multiple_facturation}} {{unite_facturation}}',
    'ajouter_cette_commande_panier': 'Alle Artikel in den Warenkorb legen',
    'ajouter_cette_commande_panier_tooltip': 'Durch Klicken werden alle Artikel für das aktuell ausgewählte Lieferdatum in einen neuen Warenkorb gelegt.',
    'vous_souhaitez_renouveler_commande': 'Erneut bestellen',
    'gagner_temps': 'Für eine neue Lieferung!',
    'a_payer': 'Zu zahlen',
    'payee': 'Bezahlt',
    'aucune_commande': 'Sie haben keine Bestellung in diesem Zeitraum',
    'tooltip_tva': 'Mehrwertsteuerbetrag',
    'produits': 'Produkte',
    'statut': 'Status',
    'statut_tooltip': 'Status der Bestellung',
    'actions': 'Aktionen',
    'deja_commande': 'Bereits bestellt:',
    'pour_livraison_du': 'Für Ihre Lieferung am {{date}}',
    'deja_commande_tooltip_ligne1': 'Sie haben bereits',
    'deja_commande_tooltip_ligne2': '<bold>{{quantite}} {{unite}}</bold> für den <bold>{{date}}</bold> bestellt',
    'type': 'Bestellart',
    'articles_ajouter_au_panier': 'Die Produkte wurden mit den gleichen Mengen in den Warenkorb gelegt.',
    'AF': 'GUTSCHRIFT',
    'AV': 'GUTSCHRIFT',
    'CA': 'BESTELLUNG',
    'CO': 'BESTELLUNG',
    'FC': 'BESTELLUNG',
    'FF': 'REGULIERUNG',
    'FQ': 'REGULIERUNG',
    'MD': 'MEHRERE EMPFÄNGER',
    'PD': 'BESTELLUNG',
    'PH': 'HISTORISCHE PROGNOSE',
    'PR': 'PROGNOSE',
    'passee_le': 'Bestellung aufgegeben am',
    'adresse_facturation': 'Rechnungsadresse',
    'adresse_livraison': 'Lieferadresse',
    'reference_de_commande': 'Bestellreferenz',
    'ajouter_produit': 'Um ein Produkt hinzuzufügen',
    'supprimer_produit_changer_quantite': 'Um ein Produkt zu entfernen oder Mengen zu ändern',
    'je_souhaite': 'Ich möchte',
    'ajouter_un_produit': 'Ein Produkt hinzufügen',
    'je_passe_une_nouvelle_commande': 'Ich gebe eine neue Bestellung auf',
    'supprimer_produit_changer_quantites': 'Ein Produkt entfernen, Mengen ändern',
    'je_contact_mon_conseiller': 'Ich kontaktiere meinen Berater',
    'renouveler_cette_commande': 'Diese Bestellung erneuern',
    'j_ajoute_tous_ces_produits': 'Ich füge alle diese Produkte meinem Warenkorb hinzu'
  },
  'factures_avoirs': {
    'facture': 'Rechnung',
    'avoir': 'Gutschrift',
    'factures_et_avoirs': '{{count}} RECHNUNG UND GUTSCHRIFT',
    'factures_et_avoirs_one': '{{count}} RECHNUNG UND GUTSCHRIFT',
    'factures_et_avoirs_other': '{{count}} RECHNUNGEN UND GUTSCHRIFTEN',
    'factures_et_avoirs_many': '{{count}} RECHNUNGEN UND GUTSCHRIFTEN',
    'factures_et_avoirs_plural': '{{count}} RECHNUNGEN UND GUTSCHRIFTEN',
    'facture_n°': 'Rechnung Nr.',
    'date_emission': 'Ausstellungsdatum',
    'echeance': 'Fälligkeit',
    'total_ttc': 'Gesamt Brutto',
    'total_ht': 'Gesamt Netto',
    'statut': 'Status',
    'action': 'Aktion',
    'telecharger': 'Herunterladen',
    'telecharger_tout': 'Alle herunterladen',
    'n°': 'Nr.',
    'numero_de_facture': 'Rechnungsnummer',
    'factures': 'Rechnungen',
    'avoirs': 'Gutschriften',
    'alerte': 'Achtung! Der Status der Rechnung wird nur einmal täglich aktualisiert.',
    'aucune_facture_ou_avoir': 'Für diesen Zeitraum sind keine Rechnungen oder Gutschriften verfügbar.',
    '2_derniers_mois': 'Die letzten 2 Monate',
    '6_derniers_mois': 'Die letzten 6 Monate',
    '12_derniers_mois': 'Die letzten 12 Monate'
  },
  'recherche': {
    'resultat_pour_mobile': 'Die Ergebnisse für',
    'resultat_pour_desktop': 'Die Suchergebnisse für',
    'recherche_produits': 'Ein Produkt suchen',
    'chargement_catalogue': 'Wir laden Ihren Katalog ...',
    'voir_tous_les_produits': 'Alle Produkte anzeigen',
    'produits': 'Produkte',
  },
  'fiche_produit': {
    'description': 'Beschreibung',
    'caracteristiques': 'Merkmale',
    'dimensions_mm': 'Maße (mm)',
    'poids_net': 'Nettogewicht',
    'poids_net_kg': '{{value}} kg',
    'table': {
      'ingredient_nutrition': 'Zutaten und Nährwerte',
      'informations_nutritionelles': 'Nährwertinformationen',
      'pour100gml': 'Pro 100 g/ml',
      'ajr': 'Empfohlene Tagesdosis (%)',
      'ajr_short': 'ETD',
      'ingredients_manquants': 'Die Zutatenliste wurde noch nicht mitgeteilt.',
      'allergenes': 'Allergene:'
    },
    'fiche_produit_pdf': {
      'telecharger_fiche_produit': 'Produktdatenblatt herunterladen.',
      'fiche_produit_non_disponible': 'Produktdatenblatt nicht verfügbar',
      'fiche_produit': 'Produktdatenblatt',
      'fiche_technique_pdf': 'Datenblatt.pdf'
    },
    'apercu_produit': 'Produktvorschau',
    'voir_detail_produit': 'Produktdetails anzeigen'
  },
  'select_client': {
    'greeting': 'Schön, Sie wiederzusehen!',
    'selectionnez_compte': 'Wählen Sie ein Kundenkonto aus, um fortzufahren',
    'client_de': 'Kunde von {{nom_societe}}',
    'mon_catalogue_france_frais': 'Mein France Frais Katalog'
  },
  'menu_catalogue': {
    'suggestion_produit': 'Im Moment',
    'catalogues_partenaires': 'Partnerkatalog-Produkte',
    'catalogue_MATFER01': 'Matfer Katalog'
  },
  'catalogue': {
    'aucun_produit': 'Keine Produkte in dieser Abteilung!',
    'les_promotions': 'Die Angebote',
    'les_indispensables': 'Die Unverzichtbaren',
    'indispensables': 'Unverzichtbar',
    'promotions': 'Angebote',
    'promotion_du_moment': 'Die aktuellen Angebote',
    'voir_tout_promotion': 'Alle Angebote ansehen',
    'voir_tout': 'Alle ansehen',
    'plus_de_produit': 'Mehr Produkte',
    'commander_maintenant': 'Jetzt bestellen',
    'commander_maintenant_pour': 'Jetzt bestellen für',
    'produits_marque_proprietaire': 'Die Unverzichtbaren',
    'fin_liste': 'Ende Ihres Katalogs',
    'filtre': {
      'promotions': 'Aktionen',
      'produit_marche': 'Marktprodukte',
      'promo': 'Angebot',
      'labels': 'Labels',
      'no_labels': 'Keine Labels',
      'origine': 'Herkunft',
      'a-z': 'A - Z',
      'pertinence': 'Relevanz',
      'tri': 'Sortieren:',
      'filtrer': 'Filtern',
      'trier': 'Sortieren',
      'trier_par': 'Sortieren nach',
      'afficher': 'Anzeigen',
      'tout_effacer': 'Alles löschen',
      'non_surgele_surgele': 'Nicht tiefgekühlt/Tiefgekühlt',
      'non_surgele': 'Nicht tiefgekühlt',
      'surgele': 'Tiefgekühlt',
      'effacer': 'Alle Filter löschen',
      'sourcing': 'Beschaffung',
      'afficher_marketplace': 'Partnerkataloge',
      'fromage': 'Käseeigenschaften',
      'famille_fromage': 'Käseart',
      'type_de_lait': 'Milchart',
      'traitement_thermique_du_lait': 'Milchbehandlung',
    }
  },
  'fromage': {
    'famille': {
      'CH': 'Ziegenkäse',
      'FF': 'Schmelzkäse',
      'PF': 'Frischkäse',
      'PMCF': 'Weichkäse mit Schimmelrinde',
      'PMCL': 'Weichkäse mit gewaschener Rinde',
      'PP': 'Blauschimmelkäse',
      'PPC': 'Hartkäse',
      'PPNC': 'Halbhartkäse',
    },
    'lait': {
      'BR': 'Schaf',
      'BU': 'Büffel',
      'CH': 'Ziege',
      'CB': 'Ziege-Schaf',
      'VA': 'Kuh',
      'VB': 'Kuh-Schaf',
      'VC': 'Kuh-Ziege',
      'VCB': 'Kuh-Ziege-Schaf',
    },
    'traitement': {
      'LMF': 'Mikrofiltrierte Milch',
      'LC': 'Rohmilch',
      'LP': 'Pasteurisierte Milch',
      'LS': 'Sterilisierte Milch',
      'LT': 'Thermisierte Milch',
      'LCLT': 'Thermisierte und Rohmilch',
    },
  },
  'accueil': {
    'bonjour': 'Hallo {{nom}}!',
    'salutation': {
      'bonjour': 'Hallo {{prenom}},',
      'bonjour_sans_prenom': 'Hallo,',
      'pret_a_commander_chez': 'bereit, bei {{societe}} zu bestellen?',
      'pret_a_commander': 'bereit zu bestellen?',
    },
    'mes_dernieres_commandes': 'Meine letzten Bestellungen',
    'cartes': {
      'cadencier': {
        'sous_titre': 'Ihre regelmäßigen Produkte',
      },
      'listes': {
        'sous_titre': 'Ihre Lieblingsprodukte',
      },
      'saison': {
        'sous_titre': 'Ihre Bestellungen vom gleichen Zeitraum des Vorjahres',
      },
    },
    'pastille_client': {
      'aria_label': 'Lieferstelle: {{raison_sociale}}, {{ville}}',
      'aria_label_sans_ville': 'Lieferstelle: {{raison_sociale}}',
    },
    'image_ambiance': {
      'alt': 'Stimmungsbild für Ihre Branche',
    },
    'chargement_catalogue': 'Wir laden Ihren Katalog. Bei Ihrer ersten Anmeldung kann dies 2 Minuten dauern, vielen Dank für Ihre Geduld.',
    'chargement_tournees': 'Laden Ihrer Lieferfahrten',
    'compte_bloque': 'Ihr Konto ist nicht für Bestellungen konfiguriert, bitte kontaktieren Sie Ihren Vertreter.',
    'mes_paniers_en_cours': 'Meine laufenden Warenkörbe ({{nombre_paniers}})',
    'paniers_en_cours': 'Laufende Warenkörbe ({{nombre_paniers}})',
    'afficher_paniers': 'Alle meine Warenkörbe anzeigen',
    'voir_paniers': 'Ansehen',
    'pour_livraison': 'Für Lieferung am ',
    'operation_commerciale': {
      'titre': 'Im Moment',
      'voir_tout': 'Alle ansehen'
    },
    'devis_personnalises': {
      'titre': 'Mein Verkaufsangebot',
      'prepare_par_label': 'Vorbereitet von',
      'prepare_par_commercial': 'Vorbereitet von {{prenom}} {{nom}} — aktualisiert am {{date}}',
      'voir_le_devis': 'Das Angebot ansehen',
      'votre_commercial': 'Ihr Vertriebsmitarbeiter ',
      'mise_a_jour': 'Aktualisiert am {{date}}',
      'nouveau_message': '{{count}} neue Nachricht',
      'nouveau_message_one': '{{count}} neue Nachricht',
      'nouveau_message_other': '{{count}} neue Nachrichten',
      'messages': '{{count}} Nachricht',
      'messages_one': '{{count}} Nachricht',
      'messages_other': '{{count}} Nachrichten',
      'messages_singulier': '{{count}} Nachricht',
      'messages_pluriel': '{{count}} Nachrichten',
      'nouveau_message_singulier': '{{count}} neue Nachricht',
      'nouveau_message_pluriel': '{{count}} neue Nachrichten'
    }
  },
  'footer': {
    'conseiller_ecoute': 'Für Sie da',
    'conseiller_ecoute_grand_compte': 'Kontaktieren Sie Ihren Vertriebsmitarbeiter',
    'mail': 'Per E-Mail',
    'telephone': 'Per Telefon',
    'consulter_rayons': 'Unsere Abteilungen durchsuchen',
    'nos_rayons': 'Unsere Abteilungen',
    'a_propos': 'Über uns',
    'contactez_nous': 'Kontaktieren Sie uns',
    'tel': 'Tel.',
    'e_mail': 'E-Mail.',
    'votre_conseiller': 'Ihr Berater:',
    'mentions_legales': 'Impressum',
    'engagements': 'Unsere Verpflichtungen',
    'politique_confidentialite': 'Datenschutzrichtlinie',
    'gestion_cookies': 'Cookie-Verwaltung',
    'cgv': 'AGB',
    'cgu': 'Nutzungsbedingungen'
  },
  'informations_legales': {
    'titre': 'Rechtliche Informationen',
    'consulter': 'Ansehen',
    'lien_externe': 'Externer Link',
    'document_pdf': 'PDF-Dokument',
    'cgv': 'Allgemeine Verkaufsbedingungen',
    'cgu': 'Nutzungsbedingungen'
  },
  'modale_nomenclature': {
    'chargement': 'Laden Ihres Menüs'
  },
  'modale_enlevement': {
    'contacter_representant': 'Um die Abholung Ihrer Waren zu organisieren, vergessen Sie nicht, Ihren Vertreter zu kontaktieren'
  },
  'modale_differer': {
    'deplacement': 'Ihr Produkt wird in den Warenkorb vom <strong>{{date_de_livraison}} verschoben</strong>',
    'aucune_livraison_possible': 'Nach diesem Datum ist vorerst keine Lieferung möglich.'
  },
  'preferences': {
    'alertes': 'Meine Bestellwarnungen',
    'activer': 'Alle aktivieren',
    'email': 'E-Mail',
    'mobile': 'Mobile App',
    'livraison': 'Erinnerung an die nächste Lieferung (am Vortag)',
    'livraison_mobile': 'Erinnerung an die nächste Lieferung<br />(am Vortag)',
    'paniers': 'Erinnerung an zu bestätigende Warenkörbe',
    'mode_assistance_01': 'Die Einstellungen im Kundenkonto sind für jeden Kontakt individuell und nicht kundenübergreifend. <strong>Es ist daher nicht möglich, diese Einstellungen im Assistenzmodus zu ändern.</strong>',
    'mode_assistance_02': 'Wenn ein Kontakt seine Einstellungen ändern möchte, muss er sich selbst bei France Frais Connect anmelden und diese im Bereich „Meine Einstellungen“ verwalten.'
  },
  'session': {
    'session_bientot_expiree': 'Sitzung läuft bald ab',
    'prolonger_session': 'Sitzung verlängern',
    'prolongation': 'Verlängerung ...',
    'delai_expiration': 'Ihre Sitzung läuft in {{minutes}} Minuten ab.'
  },
  'form': {
    'file_drop_zone': {
      'erreur_taille_fichier': 'Die Datei überschreitet die maximal zulässige Größe (5 MB)',
      'erreur_envoi_fichier': 'Das Hochladen der Datei ist fehlgeschlagen, bitte versuchen Sie es erneut.'
    },
    'societe_commerciale': {
      'titleAjouter': 'Eine Handelsgesellschaft hinzufügen',
      'titleModifier': 'Eine Handelsgesellschaft ändern',
      'dropzone': 'Legen Sie Ihre Datei hier ab oder klicken Sie auf den Bereich',
      'ajouter': 'Hinzufügen',
      'modifier': 'Ändern',
      'ajoutee': 'Die Handelsgesellschaft wurde registriert.',
      'modifiee': 'Die Handelsgesellschaft wurde geändert.',
      'supprimer': 'Löschen',
      'ajouter_lien': 'Einen Link hinzufügen',
      'annuler': 'Abbrechen',
      'valider': 'Bestätigen',
      'general': 'Allgemeine Informationen',
      'id_base_label': 'Basis-ID',
      'id_base_placeholder': 'Wählen Sie die Basis-ID',
      'code_societe_commerciale_label': 'Code der Handelsgesellschaft',
      'code_societe_commerciale_placeholder': 'Wählen Sie den Code der Gesellschaft',
      'nom_commercial_label': 'Handelsname',
      'nom_commercial_placeholder': 'Handelsname der Gesellschaft',
      'ffconnect': 'FFConnect-Informationen',
      'permettre_commande_retrait_label': 'Abholung der Bestellung erlauben',
      'permettre_commentaire_commande_label': 'Einen Kommentar zur Bestellung erlauben',
      'permettre_traduction_allemande_label': 'Deutsche Übersetzung für kommerzielle Operationen erlauben',
      'message_validation_livraison_label': 'Nachricht bei Lieferbestätigung',
      'message_validation_livraison_placeholder': 'Nachricht bei der Bestätigung einer Lieferung',
      'message_validation_enlevement_label': 'Nachricht bei Abholbestätigung',
      'message_validation_enlevement_placeholder': 'Nachricht bei der Bestätigung einer Abholung im Depot',
      'contact': 'Kontaktinformationen',
      'adresse_label': 'Adresse',
      'adresse_placeholder': 'Adresse der Gesellschaft',
      'telephone_label': 'Telefon',
      'telephone_placeholder': 'Telefon der Gesellschaft',
      'email_label': 'E-Mail',
      'email_placeholder': 'E-Mail der Gesellschaft',
      'visuel': 'Visuelle Informationen',
      'couleur_label': 'Hauptfarbe der Gesellschaft',
      'logo_label': 'Logo der Gesellschaft (jpg oder png)',
      'cgv_label': 'AGB der Gesellschaft (pdf)',
      'reinitialiser_cgv': 'AGB-Akzeptanzen zurücksetzen',
      'reinitialiser_cgv_tooltip': 'Setzt die AGB-Akzeptanzen für alle Kunden dieser Gesellschaft zurück. Sie müssen die AGB erneut akzeptieren.',
      'reinitialiser_cgv_modal': {
        'titre': 'AGB-Akzeptanzen zurücksetzen',
        'message': 'Sind Sie sicher, dass Sie die AGB-Akzeptanzen für alle Kunden dieser Gesellschaft zurücksetzen möchten? Sie müssen die AGB bei ihrer nächsten Bestellung erneut akzeptieren.',
        'confirmer': 'Zurücksetzen',
        'annuler': 'Abbrechen'
      },
      'cgu_label': 'Nutzungsbedingungen der Gesellschaft (pdf)',
      'footer': 'Footer-Informationen',
      'url_lien': 'URL für den Link',
      'label_lien': 'Link-Bezeichnung'
    }
  },
  'commercial': {
    'retour_fiche_client': 'Zurück zur Kundenkarte',
    'commandes_pdf': 'PDF-Bestellungen',
    'mode_commercial': 'Commerce-Ansicht',
    'mode_client': 'Kundenansicht',
  },
  'kpis': {
    'erreur': 'Fehler beim Laden der KPIs',
    'total_clients': 'Gesamtkunden',
    'nb_connectes': 'Verbundene Kunden',
    'nb_connectes_tooltip': '• {{nb_connectes}} Kunden haben sich in den letzten 30 Tagen bei FFConnect angemeldet.<br />• {{nb_connectes_total}} Kunden haben sich seit Beginn bei FFConnect angemeldet.',
    'non_connecte': 'nicht verbunden',
    'non_connecte_tooltip': 'Kunden, die sich in den letzten 30 Tagen nicht bei FFConnect angemeldet haben.',
    'avec_panier': 'Die einen Warenkorb erstellt haben',
    'avec_panier_tooltip': '• {{periode_en_cours}} Kunden haben in den letzten 30 Tagen einen FFConnect-Warenkorb erstellt.<br />• {{nb_avec_panier_total}} Kunden haben seit Beginn einen FFConnect-Warenkorb erstellt.',
    'sans_panier': 'kein Warenkorb',
    'sans_panier_tooltip': 'Kunden, die in den letzten 30 Tagen keinen Warenkorb auf FFConnect erstellt haben.',
    'panier_valide': 'Die einen Warenkorb bestätigt haben',
    'panier_valide_tooltip': '• {{periode_en_cours}} Kunden haben in den letzten 30 Tagen einen FFConnect-Warenkorb bestätigt.<br />• {{nb_panier_valide_total}} Kunden haben seit Beginn einen FFConnect-Warenkorb bestätigt.',
    'sans_commande': 'keine Web-Bestellung',
    'sans_commande_tooltip': 'Kunden, die in den letzten 30 Tagen nicht auf FFConnect bestellt haben.',
    'tendance_tooltip': 'Trend der letzten 30 Tage im Vergleich zu den 30 Tagen davor.',
    'clients_pas_connectes': 'Nicht verbundene Kunden',
    'clients_pas_commande': 'Kunden, die nicht bestellt haben',
    'clients_pas_connectes_tooltip': '• {{x30}} Kunden, die sich in den letzten 30 Tagen nicht bei FFConnect angemeldet haben<br />• {{xEver}} Kunden, die sich seit Beginn nicht bei FFConnect angemeldet haben',
    'clients_pas_commande_tooltip': '• {{x30}} Kunden, die in den letzten 30 Tagen nicht auf FFConnect bestellt haben (unter den verbundenen Kunden)<br />• {{xEver}} Kunden, die seit Beginn nicht auf FFConnect bestellt haben (unter den verbundenen Kunden)'
  },
  'analytics': {
    'modale_consentement_titre': 'Möchten Sie zur Verbesserung von France Frais Connect beitragen, indem Sie Nutzungsstatistiken teilen?',
    'amelioration_france_frais_connect': 'Verbesserung France Frais Connect',
    'j_accepte_le_partage': 'Ich akzeptiere das Teilen'
  },
  'maintenance': {
    'title': 'Wartungsarbeiten im Gange',
    'contact_support': 'Bei Fragen wenden Sie sich bitte an den technischen Support.'
  },
  'historique_livraison': {
    'title': 'Verlauf',
    'aucun_historique': 'Kein Verlauf verfügbar.',
    'historique_achat': 'Kaufhistorie',
    'historique_achat_tooltip': 'Kaufhistorie des Produkts in den letzten 90 Tagen.',
    'pas_historique_achat_recent': 'Kein aktueller Verlauf',
    'derniers_achats': 'Letzte 5 Käufe',
    'voir_plus': 'Mehr anzeigen',
    'prix': 'Preis',
    'categorie': 'Kategorie',
    'prix_unitaire': '{{prix}} € netto/{{unite}}',
    'prix_unitaire_avec_quantite': '{{quantite}} {{uniteQuantite}} zu {{prix}} € netto/{{unite}}',
    'evolution': {
      'en-hausse': {
        'titre': 'Position steigend',
        'description': 'Das in den letzten 30 Tagen ({{p1}}) bestellte Gewicht ist gegenüber den vorherigen 30 Tagen ({{p2}}) um mindestens 30 % gestiegen.',
      },
      'gagne': {
        'titre': 'Position gewonnen',
        'description': 'In den letzten 30 Tagen ({{p1}}) bestellt, obwohl in den 30 Tagen davor ({{p2}}) keine Bestellung vorlag.',
      },
      'stable': {
        'titre': 'Position stabil',
        'description': 'Die in den letzten 30 Tagen ({{p1}}) bestellte Menge entspricht den vorherigen 30 Tagen ({{p2}}) (Abweichung unter 30 %).',
      },
      'en-baisse': {
        'titre': 'Position rückläufig',
        'description': 'Das in den letzten 30 Tagen ({{p1}}) bestellte Gewicht ist gegenüber den vorherigen 30 Tagen ({{p2}}) um mindestens 30 % gesunken.',
      },
      'perdu': {
        'titre': 'Position verloren',
        'description': 'In den letzten 30 Tagen ({{p1}}) nicht bestellt, obwohl in den 30 Tagen davor ({{p2}}) Bestellungen vorlagen.',
      },
      'a-gagner': {
        'titre': 'Position nicht bestellt',
        'description': 'In den letzten 60 Tagen ({{p3}}) nicht bestellt.',
      },
    },
  },
  'grand_compte': {
    'chercher_un_produit': 'Ein Produkt suchen',
    'decouvrez_nos_gammes': 'Entdecken Sie unsere Produktreihen',
    'categories': 'Alle Abteilungen',
    'sav_question': 'Haben Sie eine Frage?',
    'erreur_categories': 'Fehler beim Laden der Kategorien',
    'conditionnement': 'Verpackung',
    'voir_details': 'Details ansehen',
    'rechercher_placeholder': 'Ein Produkt suchen',
    'affiner_par_rayons': 'Nach Abteilung verfeinern:',
    'resultats': 'Ergebnisse:',
    'reference': 'Referenziert',
    'detention': 'Vertrieb',
    'nombre_societes_one': '{{count}} Gesellschaft',
    'nombre_societes_other': '{{count}} Gesellschaften',
    'reference_par': {
      'groupe': 'National',
      'filiale': 'Tochtergesellschaft'
    },
    'detention_section': {
      'title_one': 'Vertrieb – vermarktet in {{count}} Gesellschaft',
      'title_other': 'Vertrieb – vermarktet in {{count}} Gesellschaften',
      'title_many': 'Vertrieb – vermarktet in {{count}} Gesellschaften',
      'title_plural': 'Vertrieb – vermarktet in {{count}} Gesellschaften',
      'societe_commerciale': 'Vertriebsgesellschaft',
      'vendu_3_derniers_mois': 'In den letzten 3 Monaten verkauft',
      'vendu_3_derniers_mois_tooltip': 'In den letzten 3 Monaten verkaufte Mengen',
      'aucune_societe_vendu': 'Kein Unternehmen hat dieses Produkt in den letzten 3 Monaten verkauft'
    }
  },
  'calendar': {
    'weekdays': {
      'short': [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
      ]
    }
  },
  'codes': {
    'code_client': 'Kundenartikelcode:',
    'code_generique': 'Generischer Code:'
  },
  'debug': {
    'produit_marche': {
      'titre': 'Debug Marktprodukt',
      'client_id': 'Kunden-ID:',
      'charger_infos': 'Allgemeine Informationen laden',
      'statut_affichage_produit_marche_bo': 'Anzeige des Marktprodukts im BO',
      'affichage_produit_marche': 'Marktproduktanzeige:',
      'tester_un_article': 'Einen Artikel testen',
      'tester_article': 'Den Artikel testen',
      'test_article': 'Test des Artikels:',
      'statistiques_catalogue': 'Katalogstatistiken',
      'total_articles_catalogue': 'Gesamtzahl der Artikel im Katalog',
      'articles_produit_marche': 'Marktproduktartikel',
      'pourcentage_produit_marche': 'Prozentsatz der Marktproduktartikel',
      'metriques': 'Metriken',
      'valeur': 'Wert',
      'existe_catalogue': 'Existiert im Katalog',
      'produit_marche_selon_tolede': 'Marktprodukt laut Tolede',
      'sera_affiche_produit_marche': 'Wird als Marktprodukt angezeigt'
    }
  },
  'mes_droits': {
    'title': 'Meine Rechte',
    'error_loading': 'Fehler beim Laden der Rechte',
    'no_data': 'Keine Daten verfügbar',
    'synako_user_info': 'Sie sehen die Rechte des aktuell ausgewählten Handelsvertreters',
    'user_info': 'Benutzerinformationen',
    'code_utilisateur': 'Benutzercode',
    'nom_prenom': 'Name',
    'email': 'E-Mail',
    'not_specified': 'Nicht angegeben',
    'permissions': 'Berechtigungen',
    'dero_autorisee': 'Zeilenweise Ausnahmeinjektion (Bestellung)',
    'devis_en_tarif_autorise': 'Ausnahmevalidierung (Angebot)',
    'prix_plancher_autorise': 'Unter Mindestpreis',
    'access_scope': 'Zugriffsbereich',
    'societes_autorisees': 'Autorisierte Handelsgesellschaften',
    'all_societies': 'Alle Gesellschaften',
    'client_autorises': 'Autorisierte Kunden',
    'all_clients': 'Alle Kunden',
    'refresh_button': 'Meine Rechte aktualisieren',
    'refresh_success': 'Rechte erfolgreich aktualisiert',
    'refresh_error': 'Fehler beim Aktualisieren der Rechte'
  },
  'mes_droits_synako': {
    'title': 'Handelsvertreter-Auswahl',
    'error_loading': 'Fehler beim Laden der Handelsvertreterliste',
    'info_message': 'Wählen Sie den France Frais Handelsvertreter aus, den Sie verkörpern möchten',
    'change_success': 'Handelsvertreter erfolgreich ausgewählt',
    'filters': 'Filter',
    'search': 'Suche',
    'search_placeholder': 'Nach Name, E-Mail oder Code suchen...',
    'filter_societe': 'Handelsgesellschaft',
    'all_societies': 'Alle Gesellschaften',
    'filter_dero': 'Zeilenweise Ausnahme-Injektion (Bestellung)',
    'filter_devis_tarif': 'Ausnahmevalidierung (Angebot)',
    'filter_prix_plancher': 'Mindestpreis',
    'list_title': 'Verfügbare Handelsvertreter',
    'no_results': 'Kein Handelsvertreter mit diesen Kriterien gefunden',
    'table': {
      'code': 'Code',
      'nom': 'Name',
      'email': 'E-Mail',
      'societes': 'Gesellschaften',
      'clients': 'Kunden',
      'dero': 'Ausnahme',
      'devis_tarif': 'Angebot/Tarif',
      'prix_plancher': 'Mindestpreis',
      'action': 'Aktion'
    },
    'all': 'Alle',
    'select': 'Auswählen'
  },
  'branding': {
    'annonce_nouvelle_identite': {
      'titre': 'France Frais hat ein neues Aussehen!',
      'texte': 'Wir präsentieren uns mit einer neuen Identität.'
    },
    'slogan': 'Eine Föderation von Händlern, <br />die Landwirten gehört.'
  },
  'file_size': {
    'zero_bytes': '0 Bytes',
    'bytes': 'Bytes',
    'kb': 'KB',
    'mb': 'MB',
    'gb': 'GB'
  },
  'client': {
    'conversations': {
      'titre': 'Gespräche',
      'sous_titre': 'Unser Telefonverkauf und Ihr Vertriebsmitarbeiter sind für Sie da',
      'sous_titre_commercial': 'mit {{raison_sociale}}',
      'equipe_aide': 'Unser Team ist für Sie da',
      'commencer_conversation': 'Gespräch starten',
      'appeler': '{{nom}} anrufen',
      'bouton_appeler': 'Anrufen',
      'reduire_chatbox': 'Chatbox minimieren',
      'onglet_en_cours': 'Meine Gespräche',
      'onglet_toutes': 'Alle Gespräche',
      'onglet_terminees': 'Beendete Konversationen',
      'aucune_conversation': 'Keine Gespräche',
      'aucune_discussion_cloturee': 'Keine abgeschlossenen Konversationen',
      'titre_defaut': 'Gespräch',
      'modifier_titre': 'Titel bearbeiten',
      'hier': 'Gestern',
      'aucun_message': 'Keine Nachrichten in diesem Gespräch.',
      'conversation_terminee': 'Dieses Gespräch wurde geschlossen. Sie können es durch Senden einer Nachricht wieder öffnen.',
      'conversation_cloturee_info': 'Dieses Gespräch ist geschlossen, Sie finden es in Ihren abgeschlossenen Gesprächen. Sie können es durch Senden einer Nachricht wieder öffnen.',
      'terminer_conversation': 'Die Antwort passt mir, Gespräch beenden.',
      'placeholder_message': 'Geben Sie Ihre Nachricht ein',
      'envoyer': 'Senden',
      'ajouter_piece_jointe': 'Dokument hinzufügen',
      'ajouter_image': 'Bild hinzufügen',
      'taille_fichier_ko': '{{taille}} KB',
      'format_non_supporte': 'Dateiformat "{{nom}}" wird nicht unterstützt (akzeptierte Formate: JPEG, PNG, GIF, WebP, PDF, Word, Excel)',
      'enregistrer_image': 'Speichern',
      'enregistrement_en_cours': 'Speichern...',
      'image_enregistree': 'Bild in der Galerie gespeichert',
      'image_enregistree_court': 'Gespeichert!',
      'erreur_enregistrement_image': 'Fehler beim Speichern des Bildes',
      'erreur_enregistrement_court': 'Fehler',
      'permission_galerie_refusee': 'Zugriff auf die Galerie verweigert',
      'taille_inconnue': 'Dateigröße von "{{nom}}" kann nicht überprüft werden',
      'nouvelle': {
        'titre': 'Neues Gespräch',
        'retour': 'Zurück',
        'message_accueil': 'Hallo,\nUm Ihre Anfrage bestmöglich zu beantworten, geben Sie bitte den Grund Ihrer Nachricht an.',
        'france_frais_connect': 'France Frais Connect',
        'raison_commande': 'Bestellung',
        'raison_compte_client': 'Kundenkonto',
        'raison_livraison': 'Lieferung',
        'raison_autres': 'Sonstiges',
        'placeholder_message': 'Geben Sie Ihre Nachricht ein',
        'envoyer': 'Senden',
        'titre_conversation_date': 'Gespräch vom {{date}}'
      }
    },
    'mes_produits': {
      'ub_essentielles': {
        'titre': 'Essenzielle UBs',
        'aucun_profil': 'Keine essenzielle UB für diesen Kunden.',
        'aucun_item_filtre': 'Keine UB entspricht diesem Filter.',
        'voir_tous_les_produits': 'Alle Produkte der UB anzeigen',
        'filtres': {
          'tout': 'Alle',
          'actives': 'Aktiv',
          'actives_one': 'Aktiv',
          'actives_other': 'Aktiv',
          'actives_many': 'Aktiv',
          'actives_plural': 'Aktiv',
          'perdu': 'Verloren',
          'perdu_one': 'Verloren',
          'perdu_other': 'Verloren',
          'perdu_many': 'Verloren',
          'perdu_plural': 'Verloren',
          'en_baisse': 'Rückläufig',
          'a_gagner': 'Zu gewinnen'
        },
        'section_statut': {
          'gagne': 'Aktive UB',
          'ras': 'Aktive UB',
          'perdu': 'Verlorene UB',
          'en-baisse': 'Rückläufige UB',
          'a-gagner': 'Zu gewinnende UB'
        },
        'section_regle': {
          'gagne': '<strong>Aktive UB</strong>: Die UB ist aktiv, wenn in den letzten 30 Tagen mindestens einer ihrer Artikel bestellt wurde.',
          'ras': '<strong>Aktive UB</strong>: Die UB ist aktiv, wenn in den letzten 30 Tagen mindestens einer ihrer Artikel bestellt wurde.',
          'perdu': '<strong>Verlorene UB</strong>: Die UB ist verloren, wenn in den letzten 30 Tagen kein Artikel bestellt wurde, verglichen mit den vorherigen 30 Tagen.',
          'en-baisse': '<strong>Rückläufige UB</strong>: Die UB ist rückläufig, wenn das Gewicht der bestellten Artikel in den letzten 30 Tagen um 30% gesunken ist, verglichen mit den vorherigen 30 Tagen.',
          'a-gagner': '<strong>Zu gewinnende UB</strong>: Die UB ist zu gewinnen, wenn in den letzten 60 Tagen kein Artikel bestellt wurde.'
        }
      }
    }
  },
  'marketplace': {
    'FF': 'Unser Katalog',
    'MATFER01': 'Matfer',
    'catalogue_MATFER01': 'Matfer-Katalog',
    'titre_catalogue': '{{nom}}-Katalog',
    'erreur_chargement_panier': 'Fehler beim Laden des Warenkorbs'
  }
};
